var _defs, _g, _g2, _g3, _g4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSixthPClear(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1120 1120",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .sixthP0C.fill,\n      .sixthP1C.fill,\n      .sixthP2C.fill,\n      .sixthP3C.fill,\n      .sixthP4C.fill,\n      .sixthP5C.fill{\n        fill: lightgrey;\n        transition: fill 0.5s ease-in-out;\n      }\n      rect{\n        fill: #fff;\n      }\n      .sixthP0C.show {\n        fill: #d95a4e;\n      }\n\n      .sixthP1C.show {\n        fill: #3a58b8;\n      }\n\n      .sixthP2C.show {\n        fill: #fff;\n      }\n\n      .sixthP3C.show {\n        fill: #780001;\n      }\n\n      .sixthP4C.show {\n        fill: #ab2727;\n      }\n\n      .sixthP5C.show {\n        fill: #0f2f7c;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP3C",
    x: 7.55,
    y: 7.46,
    width: 36,
    height: 36,
    transform: "translate(-10.52 25.52) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP3C",
    x: 33,
    y: 32.91,
    width: 36,
    height: 36,
    transform: "translate(-21.06 50.97) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP0C",
    x: 7.55,
    y: 58.36,
    width: 36,
    height: 36,
    transform: "translate(-46.51 40.43) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP0C",
    x: 58.45,
    y: 7.46,
    width: 36,
    height: 36,
    transform: "translate(4.39 61.52) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP0C",
    x: 58.46,
    y: 58.36,
    width: 36,
    height: 36,
    transform: "translate(-31.6 76.43) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP0C",
    x: 33,
    y: 83.82,
    width: 36,
    height: 36,
    transform: "translate(-57.06 65.88) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP3C",
    x: 7.55,
    y: 109.27,
    width: 36,
    height: 36,
    transform: "translate(-82.51 55.34) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP0C",
    x: 83.91,
    y: 32.91,
    width: 36,
    height: 36,
    transform: "translate(-6.15 86.97) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP3C",
    x: 109.36,
    y: 7.46,
    width: 36,
    height: 36,
    transform: "translate(19.3 97.51) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP0C",
    x: 83.91,
    y: 83.82,
    width: 36,
    height: 36,
    transform: "translate(-42.15 101.88) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP4C",
    x: 58.46,
    y: 109.27,
    width: 36,
    height: 36,
    transform: "translate(-67.6 91.34) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP4C",
    x: 58.51,
    y: 160.38,
    width: 36,
    height: 36,
    transform: "translate(-103.73 106.35) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP4C",
    x: 33,
    y: 134.72,
    width: 36,
    height: 36,
    transform: "translate(-93.05 80.79) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP4C",
    x: 109.36,
    y: 58.36,
    width: 36,
    height: 36,
    transform: "translate(-16.69 112.42) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP4C",
    x: 134.82,
    y: 32.91,
    width: 36,
    height: 36,
    transform: "translate(8.76 122.97) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP3C",
    x: 160.27,
    y: 7.46,
    width: 36,
    height: 36,
    transform: "translate(34.21 133.51) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP3C",
    x: 7.55,
    y: 160.18,
    width: 36,
    height: 36,
    transform: "translate(-118.51 70.25) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP3C",
    x: 109.36,
    y: 109.27,
    width: 36,
    height: 36,
    transform: "translate(-52.69 127.33) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP4C",
    x: 83.91,
    y: 134.72,
    width: 36,
    height: 36,
    transform: "translate(-78.14 116.79) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP4C",
    x: 134.83,
    y: 83.82,
    width: 36,
    height: 36,
    transform: "translate(-27.23 137.89) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP4C",
    x: 160.27,
    y: 58.36,
    width: 36,
    height: 36,
    transform: "translate(-1.78 148.42) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP4C",
    x: 185.72,
    y: 32.91,
    width: 36,
    height: 36,
    transform: "translate(23.67 158.96) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP3C",
    x: 211.19,
    y: 7.46,
    width: 36,
    height: 36,
    transform: "translate(49.13 169.52) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP3C",
    x: 7.55,
    y: 211.08,
    width: 36,
    height: 36,
    transform: "translate(-154.5 85.16) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP4C",
    x: 33,
    y: 185.63,
    width: 36,
    height: 36,
    transform: "translate(-129.05 95.7) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP0C",
    x: 134.82,
    y: 134.72,
    width: 36,
    height: 36,
    transform: "translate(-63.23 152.79) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP3C",
    x: 109.37,
    y: 160.18,
    width: 36,
    height: 36,
    transform: "translate(-88.68 142.25) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP4C",
    x: 83.91,
    y: 185.63,
    width: 36,
    height: 36,
    transform: "translate(-114.14 131.7) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP3C",
    x: 160.27,
    y: 109.27,
    width: 36,
    height: 36,
    transform: "translate(-37.78 163.33) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP4C",
    x: 185.73,
    y: 83.82,
    width: 36,
    height: 36,
    transform: "translate(-12.32 173.88) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP4C",
    x: 211.18,
    y: 58.36,
    width: 36,
    height: 36,
    transform: "translate(13.13 184.42) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP2C",
    x: 236.63,
    y: 32.91,
    width: 36,
    height: 36,
    transform: "translate(38.58 194.96) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP2C",
    x: 262.09,
    y: 7.46,
    width: 36,
    height: 36,
    transform: "translate(64.04 205.51) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP2C",
    x: 7.55,
    y: 261.99,
    width: 36,
    height: 36,
    transform: "translate(-190.5 100.07) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP2C",
    x: 33.01,
    y: 236.53,
    width: 36,
    height: 36,
    transform: "translate(-165.04 110.62) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP4C",
    x: 58.46,
    y: 211.08,
    width: 36,
    height: 36,
    transform: "translate(-139.59 121.16) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP0C",
    x: 160.28,
    y: 160.18,
    width: 36,
    height: 36,
    transform: "translate(-73.77 178.25) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP0C",
    x: 134.82,
    y: 185.63,
    width: 36,
    height: 36,
    transform: "translate(-99.23 167.7) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP3C",
    x: 109.36,
    y: 211.08,
    width: 36,
    height: 36,
    transform: "translate(-124.68 157.15) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP0C",
    x: 185.72,
    y: 134.72,
    width: 36,
    height: 36,
    transform: "translate(-48.32 188.78) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP3C",
    x: 211.18,
    y: 109.27,
    width: 36,
    height: 36,
    transform: "translate(-22.87 199.33) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP4C",
    x: 236.64,
    y: 83.82,
    width: 36,
    height: 36,
    transform: "translate(2.59 209.88) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP4C",
    x: 262.08,
    y: 58.36,
    width: 36,
    height: 36,
    transform: "translate(28.04 220.41) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP2C",
    x: 287.54,
    y: 32.9,
    width: 36,
    height: 36,
    transform: "translate(53.5 230.96) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP3C",
    x: 313,
    y: 7.46,
    width: 36,
    height: 36,
    transform: "translate(78.95 241.51) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP3C",
    x: 7.56,
    y: 312.9,
    width: 36,
    height: 36,
    transform: "translate(-226.49 114.99) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP2C",
    x: 33,
    y: 287.44,
    width: 36,
    height: 36,
    transform: "translate(-201.04 125.52) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP4C",
    x: 58.46,
    y: 261.99,
    width: 36,
    height: 36,
    transform: "translate(-175.59 136.07) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP4C",
    x: 83.92,
    y: 236.54,
    width: 36,
    height: 36,
    transform: "translate(-150.13 146.62) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP3C",
    x: 185.72,
    y: 185.63,
    width: 36,
    height: 36,
    transform: "translate(-84.32 203.69) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP0C",
    x: 160.27,
    y: 211.08,
    width: 36,
    height: 36,
    transform: "translate(-109.77 193.15) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP3C",
    x: 134.83,
    y: 236.54,
    width: 36,
    height: 36,
    transform: "translate(-135.22 182.62) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP0C",
    x: 211.19,
    y: 160.18,
    width: 36,
    height: 36,
    transform: "translate(-58.86 214.25) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP3C",
    x: 236.63,
    y: 134.72,
    width: 36,
    height: 36,
    transform: "translate(-33.41 224.78) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP4C",
    x: 262.08,
    y: 109.27,
    width: 36,
    height: 36,
    transform: "translate(-7.96 235.32) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP4C",
    x: 287.55,
    y: 83.82,
    width: 36,
    height: 36,
    transform: "translate(17.5 245.88) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP4C",
    x: 312.99,
    y: 58.36,
    width: 36,
    height: 36,
    transform: "translate(42.95 256.41) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP4C",
    x: 338.44,
    y: 32.91,
    width: 36,
    height: 36,
    transform: "translate(68.4 266.95) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP3C",
    x: 363.91,
    y: 7.45,
    width: 36,
    height: 36,
    transform: "translate(93.86 277.5) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP4C",
    x: 33,
    y: 338.35,
    width: 36,
    height: 36,
    transform: "translate(-237.04 140.43) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP3C",
    x: 7.55,
    y: 363.8,
    width: 36,
    height: 36,
    transform: "translate(-262.49 129.89) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP4C",
    x: 58.47,
    y: 312.9,
    width: 36,
    height: 36,
    transform: "translate(-211.58 150.99) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP4C",
    x: 83.91,
    y: 287.44,
    width: 36,
    height: 36,
    transform: "translate(-186.13 161.52) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP4C",
    x: 109.36,
    y: 261.99,
    width: 36,
    height: 36,
    transform: "translate(-160.68 172.06) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP3C",
    x: 211.18,
    y: 211.08,
    width: 36,
    height: 36,
    transform: "translate(-94.86 229.15) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP3C",
    x: 185.73,
    y: 236.54,
    width: 36,
    height: 36,
    transform: "translate(-120.31 218.61) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP0C",
    x: 160.27,
    y: 261.99,
    width: 36,
    height: 36,
    transform: "translate(-145.77 208.06) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP3C",
    x: 236.63,
    y: 185.63,
    width: 36,
    height: 36,
    transform: "translate(-69.41 239.69) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP0C",
    x: 262.09,
    y: 160.18,
    width: 36,
    height: 36,
    transform: "translate(-43.95 250.24) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP3C",
    x: 287.54,
    y: 134.72,
    width: 36,
    height: 36,
    transform: "translate(-18.5 260.78) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP3C",
    x: 312.99,
    y: 109.27,
    width: 36,
    height: 36,
    transform: "translate(6.95 271.32) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP4C",
    x: 338.45,
    y: 83.82,
    width: 36,
    height: 36,
    transform: "translate(32.41 281.87) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP4C",
    x: 363.9,
    y: 58.35,
    width: 36,
    height: 36,
    transform: "translate(57.87 292.41) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP4C",
    x: 389.35,
    y: 32.91,
    width: 36,
    height: 36,
    transform: "translate(83.31 302.95) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP3C",
    x: 414.81,
    y: 7.46,
    width: 36,
    height: 36,
    transform: "translate(108.77 313.5) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP4C",
    x: 58.46,
    y: 363.8,
    width: 36,
    height: 36,
    transform: "translate(-247.58 165.89) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP4C",
    x: 33.01,
    y: 389.25,
    width: 36,
    height: 36,
    transform: "translate(-273.03 155.35) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP3C",
    x: 7.55,
    y: 414.71,
    width: 36,
    height: 36,
    transform: "translate(-298.49 144.8) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP4C",
    x: 83.91,
    y: 338.35,
    width: 36,
    height: 36,
    transform: "translate(-222.13 176.43) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP3C",
    x: 109.37,
    y: 312.89,
    width: 36,
    height: 36,
    transform: "translate(-196.67 186.98) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP3C",
    x: 134.82,
    y: 287.44,
    width: 36,
    height: 36,
    transform: "translate(-171.22 197.52) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP2C",
    x: 236.64,
    y: 236.54,
    width: 36,
    height: 36,
    transform: "translate(-105.4 254.61) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP5C",
    x: 211.18,
    y: 261.99,
    width: 36,
    height: 36,
    transform: "translate(-130.86 244.06) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP3C",
    x: 185.72,
    y: 287.44,
    width: 36,
    height: 36,
    transform: "translate(-156.31 233.51) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP5C",
    x: 262.08,
    y: 211.08,
    width: 36,
    height: 36,
    transform: "translate(-79.95 265.14) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP3C",
    x: 287.54,
    y: 185.63,
    width: 36,
    height: 36,
    transform: "translate(-54.5 275.69) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP0C",
    x: 313,
    y: 160.18,
    width: 36,
    height: 36,
    transform: "translate(-29.04 286.24) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP0C",
    x: 338.44,
    y: 134.72,
    width: 36,
    height: 36,
    transform: "translate(-3.59 296.77) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP3C",
    x: 363.9,
    y: 109.26,
    width: 36,
    height: 36,
    transform: "translate(21.87 307.32) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP4C",
    x: 389.36,
    y: 83.82,
    width: 36,
    height: 36,
    transform: "translate(47.32 317.87) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP4C",
    x: 414.8,
    y: 58.36,
    width: 36,
    height: 36,
    transform: "translate(72.77 328.4) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP0C",
    x: 440.26,
    y: 32.9,
    width: 36,
    height: 36,
    transform: "translate(98.23 338.95) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP0C",
    x: 465.72,
    y: 7.46,
    width: 36,
    height: 36,
    transform: "translate(123.68 349.5) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP4C",
    x: 83.92,
    y: 389.26,
    width: 36,
    height: 36,
    transform: "translate(-258.12 191.35) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP4C",
    x: 58.46,
    y: 414.71,
    width: 36,
    height: 36,
    transform: "translate(-283.58 180.8) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP0C",
    x: 33,
    y: 440.16,
    width: 36,
    height: 36,
    transform: "translate(-309.03 170.25) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP0C",
    x: 7.56,
    y: 465.61,
    width: 36,
    height: 36,
    transform: "translate(-334.48 159.72) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP3C",
    x: 109.36,
    y: 363.8,
    width: 36,
    height: 36,
    transform: "translate(-232.67 201.88) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP0C",
    x: 134.82,
    y: 338.35,
    width: 36,
    height: 36,
    transform: "translate(-207.22 212.43) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP0C",
    x: 160.28,
    y: 312.9,
    width: 36,
    height: 36,
    transform: "translate(-181.76 222.98) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP3C",
    x: 516.62,
    y: 516.52,
    width: 36,
    height: 36,
    transform: "translate(-221.38 534.59) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP3C",
    x: 491.16,
    y: 491.07,
    width: 36,
    height: 36,
    transform: "translate(-210.84 509.13) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP0C",
    x: 465.71,
    y: 516.52,
    width: 36,
    height: 36,
    transform: "translate(-236.29 498.59) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP0C",
    x: 516.62,
    y: 465.62,
    width: 36,
    height: 36,
    transform: "translate(-185.38 519.68) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP0C",
    x: 465.72,
    y: 465.62,
    width: 36,
    height: 36,
    transform: "translate(-200.29 483.69) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP0C",
    x: 440.26,
    y: 491.07,
    width: 36,
    height: 36,
    transform: "translate(-225.75 473.14) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP3C",
    x: 414.8,
    y: 516.52,
    width: 36,
    height: 36,
    transform: "translate(-251.2 462.59) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP0C",
    x: 491.16,
    y: 440.16,
    width: 36,
    height: 36,
    transform: "translate(-174.84 494.22) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP3C",
    x: 516.62,
    y: 414.71,
    width: 36,
    height: 36,
    transform: "translate(-149.39 504.77) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP0C",
    x: 440.26,
    y: 440.16,
    width: 36,
    height: 36,
    transform: "translate(-189.75 458.23) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP4C",
    x: 414.81,
    y: 465.62,
    width: 36,
    height: 36,
    transform: "translate(-215.2 447.69) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP4C",
    x: 389.35,
    y: 491.07,
    width: 36,
    height: 36,
    transform: "translate(-240.66 437.14) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP4C",
    x: 465.71,
    y: 414.71,
    width: 36,
    height: 36,
    transform: "translate(-164.3 468.77) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP4C",
    x: 491.17,
    y: 389.26,
    width: 36,
    height: 36,
    transform: "translate(-138.84 479.32) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP3C",
    x: 516.62,
    y: 363.8,
    width: 36,
    height: 36,
    transform: "translate(-113.39 489.86) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP3C",
    x: 363.9,
    y: 516.52,
    width: 36,
    height: 36,
    transform: "translate(-266.11 426.6) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP3C",
    x: 414.8,
    y: 414.71,
    width: 36,
    height: 36,
    transform: "translate(-179.21 432.77) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP4C",
    x: 389.35,
    y: 440.16,
    width: 36,
    height: 36,
    transform: "translate(-204.66 422.23) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP4C",
    x: 363.91,
    y: 465.62,
    width: 36,
    height: 36,
    transform: "translate(-230.11 411.7) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP4C",
    x: 440.27,
    y: 389.26,
    width: 36,
    height: 36,
    transform: "translate(-153.75 443.33) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP4C",
    x: 465.71,
    y: 363.8,
    width: 36,
    height: 36,
    transform: "translate(-128.3 453.86) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP4C",
    x: 491.16,
    y: 338.35,
    width: 36,
    height: 36,
    transform: "translate(-102.85 464.4) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP3C",
    x: 516.63,
    y: 312.9,
    width: 36,
    height: 36,
    transform: "translate(-77.39 474.95) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP3C",
    x: 312.99,
    y: 516.52,
    width: 36,
    height: 36,
    transform: "translate(-281.02 390.6) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP4C",
    x: 338.44,
    y: 491.07,
    width: 36,
    height: 36,
    transform: "translate(-255.57 401.14) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP0C",
    x: 389.36,
    y: 389.26,
    width: 36,
    height: 36,
    transform: "translate(-168.66 407.33) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP3C",
    x: 363.9,
    y: 414.71,
    width: 36,
    height: 36,
    transform: "translate(-194.12 396.78) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP4C",
    x: 338.44,
    y: 440.16,
    width: 36,
    height: 36,
    transform: "translate(-219.57 386.23) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP3C",
    x: 414.8,
    y: 363.8,
    width: 36,
    height: 36,
    transform: "translate(-143.21 417.86) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP4C",
    x: 440.26,
    y: 338.35,
    width: 36,
    height: 36,
    transform: "translate(-117.76 428.41) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP4C",
    x: 465.72,
    y: 312.9,
    width: 36,
    height: 36,
    transform: "translate(-92.3 438.96) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP2C",
    x: 491.16,
    y: 287.44,
    width: 36,
    height: 36,
    transform: "translate(-66.85 449.49) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP2C",
    x: 516.62,
    y: 261.98,
    width: 36,
    height: 36,
    transform: "translate(-41.39 460.03) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP2C",
    x: 262.08,
    y: 516.52,
    width: 36,
    height: 36,
    transform: "translate(-295.93 354.6) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP2C",
    x: 287.54,
    y: 491.07,
    width: 36,
    height: 36,
    transform: "translate(-270.48 365.15) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP4C",
    x: 313,
    y: 465.62,
    width: 36,
    height: 36,
    transform: "translate(-245.02 375.7) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP0C",
    x: 363.9,
    y: 363.8,
    width: 36,
    height: 36,
    transform: "translate(-158.12 381.87) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP0C",
    x: 338.45,
    y: 389.26,
    width: 36,
    height: 36,
    transform: "translate(-183.57 371.33) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP3C",
    x: 312.99,
    y: 414.71,
    width: 36,
    height: 36,
    transform: "translate(-209.03 360.78) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP0C",
    x: 389.35,
    y: 338.35,
    width: 36,
    height: 36,
    transform: "translate(-132.67 392.41) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP3C",
    x: 414.81,
    y: 312.9,
    width: 36,
    height: 36,
    transform: "translate(-107.21 402.96) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP4C",
    x: 440.26,
    y: 287.44,
    width: 36,
    height: 36,
    transform: "translate(-81.76 413.5) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP4C",
    x: 465.71,
    y: 261.99,
    width: 36,
    height: 36,
    transform: "translate(-56.31 424.04) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP2C",
    x: 491.17,
    y: 236.54,
    width: 36,
    height: 36,
    transform: "translate(-30.85 434.59) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP3C",
    x: 516.62,
    y: 211.07,
    width: 36,
    height: 36,
    transform: "translate(-5.39 445.12) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP3C",
    x: 211.18,
    y: 516.52,
    width: 36,
    height: 36,
    transform: "translate(-310.84 318.61) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP2C",
    x: 236.63,
    y: 491.07,
    width: 36,
    height: 36,
    transform: "translate(-285.39 329.15) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP4C",
    x: 262.09,
    y: 465.61,
    width: 36,
    height: 36,
    transform: "translate(-259.93 339.7) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP4C",
    x: 287.54,
    y: 440.16,
    width: 36,
    height: 36,
    transform: "translate(-234.48 350.24) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP3C",
    x: 338.44,
    y: 338.35,
    width: 36,
    height: 36,
    transform: "translate(-147.58 356.41) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP0C",
    x: 312.99,
    y: 363.8,
    width: 36,
    height: 36,
    transform: "translate(-173.03 345.87) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP3C",
    x: 287.55,
    y: 389.26,
    width: 36,
    height: 36,
    transform: "translate(-198.48 335.34) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP0C",
    x: 363.91,
    y: 312.9,
    width: 36,
    height: 36,
    transform: "translate(-122.12 366.97) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP3C",
    x: 389.35,
    y: 287.44,
    width: 36,
    height: 36,
    transform: "translate(-96.67 377.5) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP4C",
    x: 414.8,
    y: 261.99,
    width: 36,
    height: 36,
    transform: "translate(-71.22 388.04) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP4C",
    x: 440.27,
    y: 236.54,
    width: 36,
    height: 36,
    transform: "translate(-45.76 398.6) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP4C",
    x: 465.71,
    y: 211.08,
    width: 36,
    height: 36,
    transform: "translate(-20.31 409.13) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP4C",
    x: 491.16,
    y: 185.63,
    width: 36,
    height: 36,
    transform: "translate(5.14 419.67) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP3C",
    x: 516.63,
    y: 160.17,
    width: 36,
    height: 36,
    transform: "translate(30.6 430.22) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP4C",
    x: 185.72,
    y: 491.07,
    width: 36,
    height: 36,
    transform: "translate(-300.3 293.15) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP3C",
    x: 160.27,
    y: 516.52,
    width: 36,
    height: 36,
    transform: "translate(-325.75 282.61) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP4C",
    x: 211.19,
    y: 465.62,
    width: 36,
    height: 36,
    transform: "translate(-274.84 303.71) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP4C",
    x: 236.63,
    y: 440.16,
    width: 36,
    height: 36,
    transform: "translate(-249.39 314.24) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP4C",
    x: 262.08,
    y: 414.71,
    width: 36,
    height: 36,
    transform: "translate(-223.94 324.78) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP3C",
    x: 313,
    y: 312.9,
    width: 36,
    height: 36,
    transform: "translate(-137.03 330.97) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP3C",
    x: 287.54,
    y: 338.35,
    width: 36,
    height: 36,
    transform: "translate(-162.49 320.42) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP0C",
    x: 262.08,
    y: 363.8,
    width: 36,
    height: 36,
    transform: "translate(-187.94 309.87) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP3C",
    x: 338.44,
    y: 287.44,
    width: 36,
    height: 36,
    transform: "translate(-111.58 341.5) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP0C",
    x: 363.9,
    y: 261.99,
    width: 36,
    height: 36,
    transform: "translate(-86.13 352.05) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP3C",
    x: 389.36,
    y: 236.54,
    width: 36,
    height: 36,
    transform: "translate(-60.67 362.6) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP3C",
    x: 414.8,
    y: 211.08,
    width: 36,
    height: 36,
    transform: "translate(-35.22 373.13) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP4C",
    x: 440.26,
    y: 185.62,
    width: 36,
    height: 36,
    transform: "translate(-9.76 383.68) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP4C",
    x: 465.72,
    y: 160.18,
    width: 36,
    height: 36,
    transform: "translate(15.69 394.23) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP4C",
    x: 491.16,
    y: 134.72,
    width: 36,
    height: 36,
    transform: "translate(41.14 404.76) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP3C",
    x: 516.62,
    y: 109.26,
    width: 36,
    height: 36,
    transform: "translate(66.6 415.3) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP4C",
    x: 160.28,
    y: 465.62,
    width: 36,
    height: 36,
    transform: "translate(-289.75 267.71) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP4C",
    x: 134.82,
    y: 491.07,
    width: 36,
    height: 36,
    transform: "translate(-315.21 257.16) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP3C",
    x: 109.36,
    y: 516.52,
    width: 36,
    height: 36,
    transform: "translate(-340.66 246.61) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP4C",
    x: 185.72,
    y: 440.16,
    width: 36,
    height: 36,
    transform: "translate(-264.3 278.24) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP3C",
    x: 211.18,
    y: 414.71,
    width: 36,
    height: 36,
    transform: "translate(-238.85 288.79) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP3C",
    x: 236.64,
    y: 389.26,
    width: 36,
    height: 36,
    transform: "translate(-213.39 299.34) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP2C",
    x: 287.54,
    y: 287.44,
    width: 36,
    height: 36,
    transform: "translate(-126.49 305.51) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP5C",
    x: 262.09,
    y: 312.9,
    width: 36,
    height: 36,
    transform: "translate(-151.94 294.97) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP3C",
    x: 236.63,
    y: 338.35,
    width: 36,
    height: 36,
    transform: "translate(-177.4 284.42) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP5C",
    x: 312.99,
    y: 261.99,
    width: 36,
    height: 36,
    transform: "translate(-101.04 316.05) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP3C",
    x: 338.45,
    y: 236.54,
    width: 36,
    height: 36,
    transform: "translate(-75.58 326.6) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP0C",
    x: 363.9,
    y: 211.08,
    width: 36,
    height: 36,
    transform: "translate(-50.13 337.14) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP0C",
    x: 389.35,
    y: 185.63,
    width: 36,
    height: 36,
    transform: "translate(-24.68 347.68) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP3C",
    x: 414.81,
    y: 160.18,
    width: 36,
    height: 36,
    transform: "translate(.78 358.23) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP4C",
    x: 440.26,
    y: 134.71,
    width: 36,
    height: 36,
    transform: "translate(26.24 368.77) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP4C",
    x: 465.71,
    y: 109.27,
    width: 36,
    height: 36,
    transform: "translate(51.68 379.31) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP0C",
    x: 491.17,
    y: 83.82,
    width: 36,
    height: 36,
    transform: "translate(77.14 389.86) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP0C",
    x: 516.62,
    y: 58.35,
    width: 36,
    height: 36,
    transform: "translate(102.6 400.39) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP4C",
    x: 134.82,
    y: 440.16,
    width: 36,
    height: 36,
    transform: "translate(-279.21 242.25) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP4C",
    x: 109.37,
    y: 465.61,
    width: 36,
    height: 36,
    transform: "translate(-304.66 231.71) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP0C",
    x: 83.91,
    y: 491.07,
    width: 36,
    height: 36,
    transform: "translate(-330.12 221.16) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP0C",
    x: 58.46,
    y: 516.52,
    width: 36,
    height: 36,
    transform: "translate(-355.57 210.62) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP3C",
    x: 160.27,
    y: 414.71,
    width: 36,
    height: 36,
    transform: "translate(-253.76 252.79) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP0C",
    x: 185.73,
    y: 389.25,
    width: 36,
    height: 36,
    transform: "translate(-228.3 263.34) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP0C",
    x: 211.18,
    y: 363.8,
    width: 36,
    height: 36,
    transform: "translate(-202.85 273.88) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP5C",
    x: 262.08,
    y: 261.99,
    width: 36,
    height: 36,
    transform: "translate(-115.95 280.05) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP2C",
    x: 236.63,
    y: 287.44,
    width: 36,
    height: 36,
    transform: "translate(-141.4 269.51) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP3C",
    x: 211.19,
    y: 312.9,
    width: 36,
    height: 36,
    transform: "translate(-166.85 258.98) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP2C",
    x: 287.55,
    y: 236.54,
    width: 36,
    height: 36,
    transform: "translate(-90.49 290.61) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP3C",
    x: 312.99,
    y: 211.08,
    width: 36,
    height: 36,
    transform: "translate(-65.04 301.14) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP3C",
    x: 338.44,
    y: 185.63,
    width: 36,
    height: 36,
    transform: "translate(-39.59 311.68) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP0C",
    x: 363.91,
    y: 160.18,
    width: 36,
    height: 36,
    transform: "translate(-14.13 322.24) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP0C",
    x: 389.35,
    y: 134.72,
    width: 36,
    height: 36,
    transform: "translate(11.32 332.77) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP3C",
    x: 414.8,
    y: 109.27,
    width: 36,
    height: 36,
    transform: "translate(36.77 343.31) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP0C",
    x: 440.27,
    y: 83.81,
    width: 36,
    height: 36,
    transform: "translate(62.23 353.86) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP0C",
    x: 465.71,
    y: 58.36,
    width: 36,
    height: 36,
    transform: "translate(87.68 364.4) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP3C",
    x: 491.16,
    y: 32.91,
    width: 36,
    height: 36,
    transform: "translate(113.13 374.94) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP3C",
    x: 516.63,
    y: 7.45,
    width: 36,
    height: 36,
    transform: "translate(138.59 385.49) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP3C",
    x: 109.36,
    y: 414.71,
    width: 36,
    height: 36,
    transform: "translate(-268.67 216.79) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP0C",
    x: 83.91,
    y: 440.16,
    width: 36,
    height: 36,
    transform: "translate(-294.12 206.25) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP0C",
    x: 58.47,
    y: 465.62,
    width: 36,
    height: 36,
    transform: "translate(-319.57 195.72) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP3C",
    x: 33,
    y: 491.06,
    width: 36,
    height: 36,
    transform: "translate(-345.03 185.16) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP3C",
    x: 7.55,
    y: 516.52,
    width: 36,
    height: 36,
    transform: "translate(-370.48 174.62) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP0C",
    x: 134.83,
    y: 389.26,
    width: 36,
    height: 36,
    transform: "translate(-243.21 227.35) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP0C",
    x: 160.27,
    y: 363.8,
    width: 36,
    height: 36,
    transform: "translate(-217.76 237.88) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP3C",
    x: 185.72,
    y: 338.35,
    width: 36,
    height: 36,
    transform: "translate(-192.31 248.42) rotate(-45)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP3C",
    x: 567.48,
    y: 567.48,
    width: 36,
    height: 36,
    transform: "translate(-242.51 585.48) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP3C",
    x: 592.93,
    y: 592.93,
    width: 36,
    height: 36,
    transform: "translate(-253.06 610.93) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP0C",
    x: 567.48,
    y: 618.39,
    width: 36,
    height: 36,
    transform: "translate(-278.51 600.39) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP0C",
    x: 618.39,
    y: 567.48,
    width: 36,
    height: 36,
    transform: "translate(-227.6 621.48) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP0C",
    x: 618.39,
    y: 618.39,
    width: 36,
    height: 36,
    transform: "translate(-263.6 636.39) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP0C",
    x: 592.93,
    y: 643.84,
    width: 36,
    height: 36,
    transform: "translate(-289.05 625.84) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP3C",
    x: 567.47,
    y: 669.29,
    width: 36,
    height: 36,
    transform: "translate(-314.51 615.3) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP0C",
    x: 643.83,
    y: 592.93,
    width: 36,
    height: 36,
    transform: "translate(-238.15 646.93) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP3C",
    x: 669.29,
    y: 567.48,
    width: 36,
    height: 36,
    transform: "translate(-212.69 657.47) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP0C",
    x: 643.84,
    y: 643.84,
    width: 36,
    height: 36,
    transform: "translate(-274.14 661.84) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP4C",
    x: 618.38,
    y: 669.29,
    width: 36,
    height: 36,
    transform: "translate(-299.6 651.29) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP4C",
    x: 618.39,
    y: 720.27,
    width: 36,
    height: 36,
    transform: "translate(-335.64 666.23) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP4C",
    x: 592.93,
    y: 694.75,
    width: 36,
    height: 36,
    transform: "translate(-325.05 640.75) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP4C",
    x: 669.29,
    y: 618.39,
    width: 36,
    height: 36,
    transform: "translate(-248.69 672.38) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP4C",
    x: 694.74,
    y: 592.93,
    width: 36,
    height: 36,
    transform: "translate(-223.24 682.92) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP3C",
    x: 720.2,
    y: 567.48,
    width: 36,
    height: 36,
    transform: "translate(-197.78 693.47) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP3C",
    x: 567.48,
    y: 720.2,
    width: 36,
    height: 36,
    transform: "translate(-350.5 630.21) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP3C",
    x: 669.28,
    y: 669.29,
    width: 36,
    height: 36,
    transform: "translate(-284.69 687.29) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP4C",
    x: 643.84,
    y: 694.75,
    width: 36,
    height: 36,
    transform: "translate(-310.14 676.75) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP4C",
    x: 694.75,
    y: 643.84,
    width: 36,
    height: 36,
    transform: "translate(-259.23 697.84) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP4C",
    x: 720.2,
    y: 618.39,
    width: 36,
    height: 36,
    transform: "translate(-233.78 708.38) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP4C",
    x: 745.64,
    y: 592.93,
    width: 36,
    height: 36,
    transform: "translate(-208.33 718.92) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP3C",
    x: 771.11,
    y: 567.48,
    width: 36,
    height: 36,
    transform: "translate(-182.87 729.47) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP3C",
    x: 567.48,
    y: 771.11,
    width: 36,
    height: 36,
    transform: "translate(-386.5 645.12) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP4C",
    x: 592.92,
    y: 745.65,
    width: 36,
    height: 36,
    transform: "translate(-361.05 655.66) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP0C",
    x: 694.75,
    y: 694.75,
    width: 36,
    height: 36,
    transform: "translate(-295.23 712.75) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP3C",
    x: 669.29,
    y: 720.2,
    width: 36,
    height: 36,
    transform: "translate(-320.68 702.2) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP4C",
    x: 643.83,
    y: 745.65,
    width: 36,
    height: 36,
    transform: "translate(-346.14 691.66) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP3C",
    x: 720.19,
    y: 669.29,
    width: 36,
    height: 36,
    transform: "translate(-269.78 723.28) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP4C",
    x: 745.65,
    y: 643.84,
    width: 36,
    height: 36,
    transform: "translate(-244.32 733.83) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP4C",
    x: 771.11,
    y: 618.39,
    width: 36,
    height: 36,
    transform: "translate(-218.87 744.38) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP2C",
    x: 796.55,
    y: 592.93,
    width: 36,
    height: 36,
    transform: "translate(-193.42 754.91) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP2C",
    x: 822.01,
    y: 567.48,
    width: 36,
    height: 36,
    transform: "translate(-167.96 765.46) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP2C",
    x: 567.47,
    y: 822.01,
    width: 36,
    height: 36,
    transform: "translate(-422.5 660.03) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP2C",
    x: 592.93,
    y: 796.56,
    width: 36,
    height: 36,
    transform: "translate(-397.04 670.57) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP4C",
    x: 618.39,
    y: 771.11,
    width: 36,
    height: 36,
    transform: "translate(-371.59 681.12) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP0C",
    x: 720.2,
    y: 720.2,
    width: 36,
    height: 36,
    transform: "translate(-305.77 738.2) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP0C",
    x: 694.74,
    y: 745.65,
    width: 36,
    height: 36,
    transform: "translate(-331.23 727.65) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP3C",
    x: 669.29,
    y: 771.11,
    width: 36,
    height: 36,
    transform: "translate(-356.68 717.11) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP0C",
    x: 745.65,
    y: 694.75,
    width: 36,
    height: 36,
    transform: "translate(-280.32 748.74) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP3C",
    x: 771.1,
    y: 669.29,
    width: 36,
    height: 36,
    transform: "translate(-254.87 759.28) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP4C",
    x: 796.56,
    y: 643.84,
    width: 36,
    height: 36,
    transform: "translate(-229.41 769.83) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP4C",
    x: 822.01,
    y: 618.39,
    width: 36,
    height: 36,
    transform: "translate(-203.96 780.37) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP2C",
    x: 847.46,
    y: 592.93,
    width: 36,
    height: 36,
    transform: "translate(-178.51 790.91) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP3C",
    x: 872.92,
    y: 567.48,
    width: 36,
    height: 36,
    transform: "translate(-153.05 801.46) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP3C",
    x: 567.48,
    y: 872.92,
    width: 36,
    height: 36,
    transform: "translate(-458.49 674.94) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP2C",
    x: 592.94,
    y: 847.46,
    width: 36,
    height: 36,
    transform: "translate(-433.03 685.49) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP4C",
    x: 618.38,
    y: 822.01,
    width: 36,
    height: 36,
    transform: "translate(-407.59 696.02) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP4C",
    x: 643.84,
    y: 796.56,
    width: 36,
    height: 36,
    transform: "translate(-382.13 706.57) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP3C",
    x: 745.64,
    y: 745.65,
    width: 36,
    height: 36,
    transform: "translate(-316.32 763.65) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP0C",
    x: 720.2,
    y: 771.11,
    width: 36,
    height: 36,
    transform: "translate(-341.77 753.11) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP3C",
    x: 694.75,
    y: 796.56,
    width: 36,
    height: 36,
    transform: "translate(-367.22 742.57) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP0C",
    x: 771.11,
    y: 720.2,
    width: 36,
    height: 36,
    transform: "translate(-290.86 774.2) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP3C",
    x: 796.56,
    y: 694.75,
    width: 36,
    height: 36,
    transform: "translate(-265.41 784.74) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP4C",
    x: 822.01,
    y: 669.28,
    width: 36,
    height: 36,
    transform: "translate(-239.95 795.28) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP4C",
    x: 847.47,
    y: 643.84,
    width: 36,
    height: 36,
    transform: "translate(-214.5 805.83) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP4C",
    x: 872.92,
    y: 618.39,
    width: 36,
    height: 36,
    transform: "translate(-189.05 816.37) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP4C",
    x: 898.37,
    y: 592.92,
    width: 36,
    height: 36,
    transform: "translate(-163.59 826.91) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP3C",
    x: 923.83,
    y: 567.48,
    width: 36,
    height: 36,
    transform: "translate(-138.14 837.46) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP4C",
    x: 592.93,
    y: 898.36,
    width: 36,
    height: 36,
    transform: "translate(-469.03 700.39) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP3C",
    x: 567.48,
    y: 923.83,
    width: 36,
    height: 36,
    transform: "translate(-494.49 689.85) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP4C",
    x: 618.39,
    y: 872.92,
    width: 36,
    height: 36,
    transform: "translate(-443.58 710.94) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP4C",
    x: 643.84,
    y: 847.47,
    width: 36,
    height: 36,
    transform: "translate(-418.13 721.48) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP4C",
    x: 669.28,
    y: 822.01,
    width: 36,
    height: 36,
    transform: "translate(-392.68 732.02) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP3C",
    x: 771.11,
    y: 771.11,
    width: 36,
    height: 36,
    transform: "translate(-326.86 789.11) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP3C",
    x: 745.65,
    y: 796.56,
    width: 36,
    height: 36,
    transform: "translate(-352.31 778.56) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP0C",
    x: 720.19,
    y: 822.01,
    width: 36,
    height: 36,
    transform: "translate(-377.77 768.01) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP3C",
    x: 796.55,
    y: 745.65,
    width: 36,
    height: 36,
    transform: "translate(-301.41 799.64) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP0C",
    x: 822.02,
    y: 720.19,
    width: 36,
    height: 36,
    transform: "translate(-275.94 810.2) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP3C",
    x: 847.47,
    y: 694.75,
    width: 36,
    height: 36,
    transform: "translate(-250.5 820.74) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP3C",
    x: 872.91,
    y: 669.29,
    width: 36,
    height: 36,
    transform: "translate(-225.05 831.27) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP4C",
    x: 898.38,
    y: 643.83,
    width: 36,
    height: 36,
    transform: "translate(-199.59 841.82) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP4C",
    x: 923.83,
    y: 618.39,
    width: 36,
    height: 36,
    transform: "translate(-174.14 852.37) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP4C",
    x: 949.27,
    y: 592.93,
    width: 36,
    height: 36,
    transform: "translate(-148.69 862.9) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP3C",
    x: 974.74,
    y: 567.47,
    width: 36,
    height: 36,
    transform: "translate(-123.23 873.45) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP4C",
    x: 618.39,
    y: 923.83,
    width: 36,
    height: 36,
    transform: "translate(-479.58 725.85) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP4C",
    x: 592.94,
    y: 949.27,
    width: 36,
    height: 36,
    transform: "translate(-505.02 715.31) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP3C",
    x: 567.47,
    y: 974.73,
    width: 36,
    height: 36,
    transform: "translate(-530.48 704.76) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP4C",
    x: 643.83,
    y: 898.37,
    width: 36,
    height: 36,
    transform: "translate(-454.12 736.39) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP3C",
    x: 669.3,
    y: 872.91,
    width: 36,
    height: 36,
    transform: "translate(-428.66 746.94) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP3C",
    x: 694.75,
    y: 847.47,
    width: 36,
    height: 36,
    transform: "translate(-403.22 757.48) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP2C",
    x: 796.56,
    y: 796.56,
    width: 36,
    height: 36,
    transform: "translate(-337.4 814.56) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP5C",
    x: 771.11,
    y: 822.02,
    width: 36,
    height: 36,
    transform: "translate(-362.86 804.02) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP3C",
    x: 745.66,
    y: 847.46,
    width: 36,
    height: 36,
    transform: "translate(-388.3 793.48) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP5C",
    x: 822.02,
    y: 771.1,
    width: 36,
    height: 36,
    transform: "translate(-311.94 825.11) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP3C",
    x: 847.46,
    y: 745.65,
    width: 36,
    height: 36,
    transform: "translate(-286.5 835.64) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP0C",
    x: 872.92,
    y: 720.2,
    width: 36,
    height: 36,
    transform: "translate(-261.04 846.19) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP0C",
    x: 898.38,
    y: 694.74,
    width: 36,
    height: 36,
    transform: "translate(-235.58 856.73) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP3C",
    x: 923.82,
    y: 669.29,
    width: 36,
    height: 36,
    transform: "translate(-210.14 867.27) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP4C",
    x: 949.28,
    y: 643.84,
    width: 36,
    height: 36,
    transform: "translate(-184.68 877.82) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP4C",
    x: 974.74,
    y: 618.38,
    width: 36,
    height: 36,
    transform: "translate(-159.22 888.36) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP0C",
    x: 1000.18,
    y: 592.93,
    width: 36,
    height: 36,
    transform: "translate(-133.78 898.9) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP0C",
    x: 1025.64,
    y: 567.48,
    width: 36,
    height: 36,
    transform: "translate(-108.32 909.45) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP4C",
    x: 643.84,
    y: 949.28,
    width: 36,
    height: 36,
    transform: "translate(-490.12 751.3) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP4C",
    x: 618.38,
    y: 974.73,
    width: 36,
    height: 36,
    transform: "translate(-515.57 740.75) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP0C",
    x: 592.94,
    y: 1000.19,
    width: 36,
    height: 36,
    transform: "translate(-541.03 730.22) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP0C",
    x: 567.48,
    y: 1025.64,
    width: 36,
    height: 36,
    transform: "translate(-566.48 719.67) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP3C",
    x: 669.3,
    y: 923.82,
    width: 36,
    height: 36,
    transform: "translate(-464.66 761.85) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP0C",
    x: 694.74,
    y: 898.37,
    width: 36,
    height: 36,
    transform: "translate(-439.21 772.38) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP0C",
    x: 720.2,
    y: 872.92,
    width: 36,
    height: 36,
    transform: "translate(-413.76 782.93) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP3C",
    x: 1076.55,
    y: 1076.55,
    width: 36,
    height: 36,
    transform: "translate(-453.38 1094.55) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP3C",
    x: 1051.11,
    y: 1051.09,
    width: 36,
    height: 36,
    transform: "translate(-442.83 1069.1) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP0C",
    x: 1025.64,
    y: 1076.55,
    width: 36,
    height: 36,
    transform: "translate(-468.29 1058.55) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP0C",
    x: 1076.55,
    y: 1025.64,
    width: 36,
    height: 36,
    transform: "translate(-417.38 1079.64) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP0C",
    x: 1025.64,
    y: 1025.64,
    width: 36,
    height: 36,
    transform: "translate(-432.29 1043.64) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP0C",
    x: 1000.2,
    y: 1051.1,
    width: 36,
    height: 36,
    transform: "translate(-457.74 1033.11) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP3C",
    x: 974.74,
    y: 1076.54,
    width: 36,
    height: 36,
    transform: "translate(-483.19 1022.55) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP0C",
    x: 1051.1,
    y: 1000.18,
    width: 36,
    height: 36,
    transform: "translate(-406.83 1054.18) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP3C",
    x: 1076.56,
    y: 974.74,
    width: 36,
    height: 36,
    transform: "translate(-381.38 1064.74) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP0C",
    x: 1000.19,
    y: 1000.19,
    width: 36,
    height: 36,
    transform: "translate(-421.75 1018.19) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP4C",
    x: 974.74,
    y: 1025.63,
    width: 36,
    height: 36,
    transform: "translate(-447.19 1007.64) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP4C",
    x: 949.29,
    y: 1051.1,
    width: 36,
    height: 36,
    transform: "translate(-472.65 997.11) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP4C",
    x: 1025.65,
    y: 974.74,
    width: 36,
    height: 36,
    transform: "translate(-396.29 1028.74) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP4C",
    x: 1051.1,
    y: 949.27,
    width: 36,
    height: 36,
    transform: "translate(-370.83 1039.27) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP3C",
    x: 1076.55,
    y: 923.83,
    width: 36,
    height: 36,
    transform: "translate(-345.39 1049.82) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP3C",
    x: 923.83,
    y: 1076.55,
    width: 36,
    height: 36,
    transform: "translate(-498.11 986.56) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP3C",
    x: 974.75,
    y: 974.73,
    width: 36,
    height: 36,
    transform: "translate(-411.2 992.74) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP4C",
    x: 949.28,
    y: 1000.19,
    width: 36,
    height: 36,
    transform: "translate(-436.66 982.19) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP4C",
    x: 923.83,
    y: 1025.64,
    width: 36,
    height: 36,
    transform: "translate(-462.11 971.65) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP4C",
    x: 1000.19,
    y: 949.28,
    width: 36,
    height: 36,
    transform: "translate(-385.75 1003.28) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP4C",
    x: 1025.64,
    y: 923.83,
    width: 36,
    height: 36,
    transform: "translate(-360.3 1013.82) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP4C",
    x: 1051.11,
    y: 898.37,
    width: 36,
    height: 36,
    transform: "translate(-334.84 1024.37) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP3C",
    x: 1076.55,
    y: 872.92,
    width: 36,
    height: 36,
    transform: "translate(-309.39 1034.91) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP3C",
    x: 872.92,
    y: 1076.55,
    width: 36,
    height: 36,
    transform: "translate(-513.02 950.56) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP4C",
    x: 898.39,
    y: 1051.09,
    width: 36,
    height: 36,
    transform: "translate(-487.56 961.11) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP0C",
    x: 949.28,
    y: 949.28,
    width: 36,
    height: 36,
    transform: "translate(-400.66 967.28) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP3C",
    x: 923.84,
    y: 974.74,
    width: 36,
    height: 36,
    transform: "translate(-426.11 956.75) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP4C",
    x: 898.38,
    y: 1000.18,
    width: 36,
    height: 36,
    transform: "translate(-451.56 946.19) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP3C",
    x: 974.74,
    y: 923.82,
    width: 36,
    height: 36,
    transform: "translate(-375.2 977.82) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP4C",
    x: 1000.2,
    y: 898.38,
    width: 36,
    height: 36,
    transform: "translate(-349.75 988.38) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP4C",
    x: 1025.64,
    y: 872.92,
    width: 36,
    height: 36,
    transform: "translate(-324.3 998.91) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP2C",
    x: 1051.1,
    y: 847.46,
    width: 36,
    height: 36,
    transform: "translate(-298.84 1009.45) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP2C",
    x: 1076.56,
    y: 822.02,
    width: 36,
    height: 36,
    transform: "translate(-273.4 1020.01) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP2C",
    x: 822.02,
    y: 1076.54,
    width: 36,
    height: 36,
    transform: "translate(-527.92 914.57) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP2C",
    x: 847.48,
    y: 1051.1,
    width: 36,
    height: 36,
    transform: "translate(-502.47 925.12) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP4C",
    x: 872.92,
    y: 1025.64,
    width: 36,
    height: 36,
    transform: "translate(-477.02 935.65) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP0C",
    x: 923.83,
    y: 923.83,
    width: 36,
    height: 36,
    transform: "translate(-390.12 941.83) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP0C",
    x: 898.38,
    y: 949.27,
    width: 36,
    height: 36,
    transform: "translate(-415.56 931.28) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP3C",
    x: 872.93,
    y: 974.74,
    width: 36,
    height: 36,
    transform: "translate(-441.02 920.75) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP0C",
    x: 949.29,
    y: 898.38,
    width: 36,
    height: 36,
    transform: "translate(-364.66 952.38) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP3C",
    x: 974.74,
    y: 872.91,
    width: 36,
    height: 36,
    transform: "translate(-339.2 962.91) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP4C",
    x: 1000.19,
    y: 847.47,
    width: 36,
    height: 36,
    transform: "translate(-313.76 973.46) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP4C",
    x: 1025.65,
    y: 822.02,
    width: 36,
    height: 36,
    transform: "translate(-288.31 984.01) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP2C",
    x: 1051.1,
    y: 796.55,
    width: 36,
    height: 36,
    transform: "translate(-262.84 994.54) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP3C",
    x: 1076.55,
    y: 771.11,
    width: 36,
    height: 36,
    transform: "translate(-237.4 1005.09) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP3C",
    x: 771.11,
    y: 1076.55,
    width: 36,
    height: 36,
    transform: "translate(-542.84 878.57) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP2C",
    x: 796.57,
    y: 1051.1,
    width: 36,
    height: 36,
    transform: "translate(-517.38 889.12) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP4C",
    x: 822.02,
    y: 1025.63,
    width: 36,
    height: 36,
    transform: "translate(-491.92 899.66) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP4C",
    x: 847.47,
    y: 1000.19,
    width: 36,
    height: 36,
    transform: "translate(-466.48 910.2) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP3C",
    x: 898.39,
    y: 898.37,
    width: 36,
    height: 36,
    transform: "translate(-379.57 916.38) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP0C",
    x: 872.92,
    y: 923.83,
    width: 36,
    height: 36,
    transform: "translate(-405.03 905.83) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP3C",
    x: 847.47,
    y: 949.28,
    width: 36,
    height: 36,
    transform: "translate(-430.48 895.29) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP0C",
    x: 923.83,
    y: 872.92,
    width: 36,
    height: 36,
    transform: "translate(-354.12 926.92) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP3C",
    x: 949.28,
    y: 847.47,
    width: 36,
    height: 36,
    transform: "translate(-328.67 937.46) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP4C",
    x: 974.75,
    y: 822.01,
    width: 36,
    height: 36,
    transform: "translate(-303.21 948.01) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP4C",
    x: 1000.19,
    y: 796.56,
    width: 36,
    height: 36,
    transform: "translate(-277.76 958.55) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP4C",
    x: 1025.64,
    y: 771.11,
    width: 36,
    height: 36,
    transform: "translate(-252.31 969.09) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP4C",
    x: 1051.11,
    y: 745.65,
    width: 36,
    height: 36,
    transform: "translate(-226.85 979.64) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP3C",
    x: 1076.55,
    y: 720.19,
    width: 36,
    height: 36,
    transform: "translate(-201.39 990.18) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP4C",
    x: 745.67,
    y: 1051.09,
    width: 36,
    height: 36,
    transform: "translate(-532.29 853.12) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP3C",
    x: 720.2,
    y: 1076.55,
    width: 36,
    height: 36,
    transform: "translate(-557.75 842.57) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP4C",
    x: 771.11,
    y: 1025.64,
    width: 36,
    height: 36,
    transform: "translate(-506.84 863.66) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP4C",
    x: 796.56,
    y: 1000.19,
    width: 36,
    height: 36,
    transform: "translate(-481.39 874.2) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP4C",
    x: 822.03,
    y: 974.73,
    width: 36,
    height: 36,
    transform: "translate(-455.93 884.75) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP3C",
    x: 872.92,
    y: 872.92,
    width: 36,
    height: 36,
    transform: "translate(-369.03 890.92) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP3C",
    x: 847.48,
    y: 898.38,
    width: 36,
    height: 36,
    transform: "translate(-394.49 880.39) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP0C",
    x: 822.02,
    y: 923.82,
    width: 36,
    height: 36,
    transform: "translate(-419.93 869.84) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP3C",
    x: 898.38,
    y: 847.46,
    width: 36,
    height: 36,
    transform: "translate(-343.57 901.46) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP0C",
    x: 923.84,
    y: 822.02,
    width: 36,
    height: 36,
    transform: "translate(-318.13 912.02) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP3C",
    x: 949.28,
    y: 796.56,
    width: 36,
    height: 36,
    transform: "translate(-292.67 922.55) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP3C",
    x: 974.74,
    y: 771.1,
    width: 36,
    height: 36,
    transform: "translate(-267.21 933.09) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP4C",
    x: 1000.2,
    y: 745.66,
    width: 36,
    height: 36,
    transform: "translate(-241.77 943.65) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP4C",
    x: 1025.64,
    y: 720.2,
    width: 36,
    height: 36,
    transform: "translate(-216.31 954.18) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP4C",
    x: 1051.1,
    y: 694.74,
    width: 36,
    height: 36,
    transform: "translate(-190.85 964.72) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP3C",
    x: 1076.56,
    y: 669.29,
    width: 36,
    height: 36,
    transform: "translate(-165.4 975.27) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP4C",
    x: 720.2,
    y: 1025.64,
    width: 36,
    height: 36,
    transform: "translate(-521.75 827.66) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP4C",
    x: 694.75,
    y: 1051.09,
    width: 36,
    height: 36,
    transform: "translate(-547.2 817.12) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP3C",
    x: 669.3,
    y: 1076.54,
    width: 36,
    height: 36,
    transform: "translate(-572.65 806.58) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP4C",
    x: 745.66,
    y: 1000.18,
    width: 36,
    height: 36,
    transform: "translate(-496.29 838.21) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP3C",
    x: 771.12,
    y: 974.74,
    width: 36,
    height: 36,
    transform: "translate(-470.84 848.76) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP3C",
    x: 796.56,
    y: 949.28,
    width: 36,
    height: 36,
    transform: "translate(-445.39 859.29) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP2C",
    x: 847.47,
    y: 847.47,
    width: 36,
    height: 36,
    transform: "translate(-358.49 865.47) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP5C",
    x: 822.02,
    y: 872.91,
    width: 36,
    height: 36,
    transform: "translate(-383.93 854.93) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP3C",
    x: 796.57,
    y: 898.38,
    width: 36,
    height: 36,
    transform: "translate(-409.39 844.39) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP5C",
    x: 872.93,
    y: 822.02,
    width: 36,
    height: 36,
    transform: "translate(-333.04 876.02) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP3C",
    x: 898.38,
    y: 796.55,
    width: 36,
    height: 36,
    transform: "translate(-307.57 886.55) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP0C",
    x: 923.83,
    y: 771.11,
    width: 36,
    height: 36,
    transform: "translate(-282.13 897.1) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP0C",
    x: 949.29,
    y: 745.66,
    width: 36,
    height: 36,
    transform: "translate(-256.68 907.65) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP3C",
    x: 974.74,
    y: 720.19,
    width: 36,
    height: 36,
    transform: "translate(-231.21 918.18) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP4C",
    x: 1000.19,
    y: 694.75,
    width: 36,
    height: 36,
    transform: "translate(-205.77 928.73) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP4C",
    x: 1025.65,
    y: 669.3,
    width: 36,
    height: 36,
    transform: "translate(-180.32 939.28) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP0C",
    x: 1051.1,
    y: 643.83,
    width: 36,
    height: 36,
    transform: "translate(-154.86 949.81) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP0C",
    x: 1076.55,
    y: 618.38,
    width: 36,
    height: 36,
    transform: "translate(-129.4 960.36) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP4C",
    x: 694.75,
    y: 1000.19,
    width: 36,
    height: 36,
    transform: "translate(-511.21 802.21) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP4C",
    x: 669.3,
    y: 1025.63,
    width: 36,
    height: 36,
    transform: "translate(-536.65 791.67) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP0C",
    x: 643.84,
    y: 1051.09,
    width: 36,
    height: 36,
    transform: "translate(-562.11 781.12) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP0C",
    x: 618.39,
    y: 1076.55,
    width: 36,
    height: 36,
    transform: "translate(-587.57 770.58) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP3C",
    x: 720.21,
    y: 974.74,
    width: 36,
    height: 36,
    transform: "translate(-485.75 812.76) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP0C",
    x: 745.66,
    y: 949.27,
    width: 36,
    height: 36,
    transform: "translate(-460.29 823.3) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP0C",
    x: 771.11,
    y: 923.83,
    width: 36,
    height: 36,
    transform: "translate(-434.85 833.84) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP5C",
    x: 822.03,
    y: 822.01,
    width: 36,
    height: 36,
    transform: "translate(-347.94 840.02) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP2C",
    x: 796.56,
    y: 847.47,
    width: 36,
    height: 36,
    transform: "translate(-373.4 829.47) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP3C",
    x: 771.11,
    y: 872.92,
    width: 36,
    height: 36,
    transform: "translate(-398.85 818.93) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP2C",
    x: 847.47,
    y: 796.56,
    width: 36,
    height: 36,
    transform: "translate(-322.49 850.56) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP3C",
    x: 872.92,
    y: 771.11,
    width: 36,
    height: 36,
    transform: "translate(-297.04 861.1) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP3C",
    x: 898.39,
    y: 745.65,
    width: 36,
    height: 36,
    transform: "translate(-271.58 871.65) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP0C",
    x: 923.83,
    y: 720.2,
    width: 36,
    height: 36,
    transform: "translate(-246.13 882.19) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP0C",
    x: 949.28,
    y: 694.75,
    width: 36,
    height: 36,
    transform: "translate(-220.68 892.73) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP3C",
    x: 974.75,
    y: 669.29,
    width: 36,
    height: 36,
    transform: "translate(-195.22 903.28) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP0C",
    x: 1000.19,
    y: 643.84,
    width: 36,
    height: 36,
    transform: "translate(-169.77 913.82) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP0C",
    x: 1025.64,
    y: 618.39,
    width: 36,
    height: 36,
    transform: "translate(-144.32 924.36) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP3C",
    x: 1051.1,
    y: 592.92,
    width: 36,
    height: 36,
    transform: "translate(-118.86 934.9) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP3C",
    x: 1076.55,
    y: 567.47,
    width: 36,
    height: 36,
    transform: "translate(-93.41 945.45) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP3C",
    x: 669.3,
    y: 974.72,
    width: 36,
    height: 36,
    transform: "translate(-500.65 776.76) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP0C",
    x: 643.84,
    y: 1000.19,
    width: 36,
    height: 36,
    transform: "translate(-526.12 766.21) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP0C",
    x: 618.39,
    y: 1025.64,
    width: 36,
    height: 36,
    transform: "translate(-551.57 755.67) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP3C",
    x: 592.94,
    y: 1051.09,
    width: 36,
    height: 36,
    transform: "translate(-577.02 745.13) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP3C",
    x: 567.48,
    y: 1076.55,
    width: 36,
    height: 36,
    transform: "translate(-602.48 734.58) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP0C",
    x: 694.75,
    y: 949.28,
    width: 36,
    height: 36,
    transform: "translate(-475.21 787.3) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP0C",
    x: 720.2,
    y: 923.83,
    width: 36,
    height: 36,
    transform: "translate(-449.76 797.84) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP3C",
    x: 745.67,
    y: 898.37,
    width: 36,
    height: 36,
    transform: "translate(-424.3 808.39) rotate(-45)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP0C",
    x: 567.47,
    y: 7.46,
    width: 36,
    height: 36,
    transform: "translate(153.48 421.45) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP0C",
    x: 592.93,
    y: 32.91,
    width: 36,
    height: 36,
    transform: "translate(142.94 446.9) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP0C",
    x: 567.47,
    y: 58.36,
    width: 36,
    height: 36,
    transform: "translate(117.48 436.36) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP0C",
    x: 618.38,
    y: 7.45,
    width: 36,
    height: 36,
    transform: "translate(168.39 457.45) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP5C",
    x: 618.38,
    y: 58.36,
    width: 36,
    height: 36,
    transform: "translate(132.4 472.36) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP0C",
    x: 592.93,
    y: 83.81,
    width: 36,
    height: 36,
    transform: "translate(106.94 461.81) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP3C",
    x: 567.47,
    y: 109.27,
    width: 36,
    height: 36,
    transform: "translate(81.49 451.27) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP0C",
    x: 643.83,
    y: 32.91,
    width: 36,
    height: 36,
    transform: "translate(157.84 482.9) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP3C",
    x: 669.29,
    y: 7.46,
    width: 36,
    height: 36,
    transform: "translate(183.3 493.44) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP5C",
    x: 643.83,
    y: 83.82,
    width: 36,
    height: 36,
    transform: "translate(121.85 497.81) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP5C",
    x: 618.38,
    y: 109.26,
    width: 36,
    height: 36,
    transform: "translate(96.4 487.27) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP5C",
    x: 618.38,
    y: 160.38,
    width: 36,
    height: 36,
    transform: "translate(60.26 502.24) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP0C",
    x: 592.93,
    y: 134.72,
    width: 36,
    height: 36,
    transform: "translate(70.95 476.72) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP5C",
    x: 669.29,
    y: 58.36,
    width: 36,
    height: 36,
    transform: "translate(147.31 508.35) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP0C",
    x: 694.74,
    y: 32.91,
    width: 36,
    height: 36,
    transform: "translate(172.76 518.89) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP3C",
    x: 720.19,
    y: 7.46,
    width: 36,
    height: 36,
    transform: "translate(198.21 529.44) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP3C",
    x: 567.47,
    y: 160.18,
    width: 36,
    height: 36,
    transform: "translate(45.49 466.18) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP5C",
    x: 669.29,
    y: 109.27,
    width: 36,
    height: 36,
    transform: "translate(111.31 523.26) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP5C",
    x: 643.83,
    y: 134.72,
    width: 36,
    height: 36,
    transform: "translate(85.85 512.72) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP5C",
    x: 694.74,
    y: 83.81,
    width: 36,
    height: 36,
    transform: "translate(136.76 533.8) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP5C",
    x: 720.19,
    y: 58.37,
    width: 36,
    height: 36,
    transform: "translate(162.21 544.35) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP0C",
    x: 745.65,
    y: 32.91,
    width: 36,
    height: 36,
    transform: "translate(187.67 554.89) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP3C",
    x: 771.1,
    y: 7.45,
    width: 36,
    height: 36,
    transform: "translate(213.12 565.43) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP3C",
    x: 567.47,
    y: 211.08,
    width: 36,
    height: 36,
    transform: "translate(9.49 481.09) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP0C",
    x: 592.93,
    y: 185.63,
    width: 36,
    height: 36,
    transform: "translate(34.95 491.63) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP5C",
    x: 694.74,
    y: 134.72,
    width: 36,
    height: 36,
    transform: "translate(100.77 548.71) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP5C",
    x: 669.29,
    y: 160.17,
    width: 36,
    height: 36,
    transform: "translate(75.31 538.17) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP1C",
    x: 643.83,
    y: 185.63,
    width: 36,
    height: 36,
    transform: "translate(49.86 527.63) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP5C",
    x: 720.19,
    y: 109.27,
    width: 36,
    height: 36,
    transform: "translate(126.22 559.26) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP1C",
    x: 745.65,
    y: 83.82,
    width: 36,
    height: 36,
    transform: "translate(151.67 569.8) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP5C",
    x: 771.1,
    y: 58.36,
    width: 36,
    height: 36,
    transform: "translate(177.13 580.34) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP0C",
    x: 796.55,
    y: 32.92,
    width: 36,
    height: 36,
    transform: "translate(202.57 590.89) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP3C",
    x: 822.01,
    y: 7.46,
    width: 36,
    height: 36,
    transform: "translate(228.03 601.43) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP3C",
    x: 567.47,
    y: 261.99,
    width: 36,
    height: 36,
    transform: "translate(-26.5 496) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP0C",
    x: 592.93,
    y: 236.53,
    width: 36,
    height: 36,
    transform: "translate(-1.05 506.54) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP5C",
    x: 618.38,
    y: 211.08,
    width: 36,
    height: 36,
    transform: "translate(24.41 517.09) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP5C",
    x: 720.19,
    y: 160.18,
    width: 36,
    height: 36,
    transform: "translate(90.22 574.17) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP5C",
    x: 694.74,
    y: 185.62,
    width: 36,
    height: 36,
    transform: "translate(64.77 563.62) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP1C",
    x: 669.29,
    y: 211.08,
    width: 36,
    height: 36,
    transform: "translate(39.32 553.08) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP5C",
    x: 745.65,
    y: 134.72,
    width: 36,
    height: 36,
    transform: "translate(115.68 584.71) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP1C",
    x: 771.1,
    y: 109.27,
    width: 36,
    height: 36,
    transform: "translate(141.13 595.25) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP1C",
    x: 796.55,
    y: 83.82,
    width: 36,
    height: 36,
    transform: "translate(166.58 605.8) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP5C",
    x: 822.01,
    y: 58.36,
    width: 36,
    height: 36,
    transform: "translate(192.04 616.34) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP0C",
    x: 847.46,
    y: 32.91,
    width: 36,
    height: 36,
    transform: "translate(217.49 626.88) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP3C",
    x: 872.91,
    y: 7.46,
    width: 36,
    height: 36,
    transform: "translate(242.94 637.43) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP3C",
    x: 567.47,
    y: 312.9,
    width: 36,
    height: 36,
    transform: "translate(-62.5 510.91) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP0C",
    x: 592.93,
    y: 287.44,
    width: 36,
    height: 36,
    transform: "translate(-37.04 521.45) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP5C",
    x: 618.38,
    y: 261.98,
    width: 36,
    height: 36,
    transform: "translate(-11.59 532) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP1C",
    x: 643.83,
    y: 236.54,
    width: 36,
    height: 36,
    transform: "translate(13.86 542.54) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP5C",
    x: 745.65,
    y: 185.63,
    width: 36,
    height: 36,
    transform: "translate(79.68 599.62) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP0C",
    x: 720.19,
    y: 211.08,
    width: 36,
    height: 36,
    transform: "translate(54.22 589.08) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP0C",
    x: 694.74,
    y: 236.53,
    width: 36,
    height: 36,
    transform: "translate(28.77 578.53) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP0C",
    x: 771.1,
    y: 160.17,
    width: 36,
    height: 36,
    transform: "translate(105.13 610.16) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP0C",
    x: 796.55,
    y: 134.73,
    width: 36,
    height: 36,
    transform: "translate(130.58 620.71) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP5C",
    x: 822.01,
    y: 109.27,
    width: 36,
    height: 36,
    transform: "translate(156.04 631.25) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP1C",
    x: 847.46,
    y: 83.81,
    width: 36,
    height: 36,
    transform: "translate(181.49 641.79) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP5C",
    x: 872.91,
    y: 58.37,
    width: 36,
    height: 36,
    transform: "translate(206.94 652.34) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP0C",
    x: 898.37,
    y: 32.91,
    width: 36,
    height: 36,
    transform: "translate(232.4 662.88) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP3C",
    x: 923.82,
    y: 7.46,
    width: 36,
    height: 36,
    transform: "translate(257.85 673.42) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP0C",
    x: 592.93,
    y: 338.34,
    width: 36,
    height: 36,
    transform: "translate(-73.04 536.36) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP3C",
    x: 567.47,
    y: 363.8,
    width: 36,
    height: 36,
    transform: "translate(-98.49 525.82) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP5C",
    x: 618.38,
    y: 312.89,
    width: 36,
    height: 36,
    transform: "translate(-47.59 546.91) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP1C",
    x: 643.83,
    y: 287.44,
    width: 36,
    height: 36,
    transform: "translate(-22.14 557.45) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP5C",
    x: 669.29,
    y: 261.99,
    width: 36,
    height: 36,
    transform: "translate(3.32 567.99) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP0C",
    x: 771.1,
    y: 211.08,
    width: 36,
    height: 36,
    transform: "translate(69.14 625.07) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP4C",
    x: 745.65,
    y: 236.53,
    width: 36,
    height: 36,
    transform: "translate(43.68 614.53) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP0C",
    x: 720.19,
    y: 261.99,
    width: 36,
    height: 36,
    transform: "translate(18.23 603.99) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP4C",
    x: 796.55,
    y: 185.63,
    width: 36,
    height: 36,
    transform: "translate(94.59 635.62) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP0C",
    x: 822.01,
    y: 160.18,
    width: 36,
    height: 36,
    transform: "translate(120.04 646.16) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP0C",
    x: 847.46,
    y: 134.72,
    width: 36,
    height: 36,
    transform: "translate(145.5 656.7) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP1C",
    x: 872.91,
    y: 109.28,
    width: 36,
    height: 36,
    transform: "translate(170.95 667.25) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP1C",
    x: 898.37,
    y: 83.82,
    width: 36,
    height: 36,
    transform: "translate(196.4 677.79) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP5C",
    x: 923.82,
    y: 58.36,
    width: 36,
    height: 36,
    transform: "translate(221.86 688.33) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP0C",
    x: 949.27,
    y: 32.92,
    width: 36,
    height: 36,
    transform: "translate(247.3 698.88) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP3C",
    x: 974.73,
    y: 7.46,
    width: 36,
    height: 36,
    transform: "translate(272.76 709.42) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP5C",
    x: 618.38,
    y: 363.8,
    width: 36,
    height: 36,
    transform: "translate(-83.58 561.82) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP0C",
    x: 592.93,
    y: 389.25,
    width: 36,
    height: 36,
    transform: "translate(-109.03 551.27) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP3C",
    x: 567.47,
    y: 414.71,
    width: 36,
    height: 36,
    transform: "translate(-134.49 540.73) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP1C",
    x: 643.83,
    y: 338.35,
    width: 36,
    height: 36,
    transform: "translate(-58.13 572.36) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP1C",
    x: 669.29,
    y: 312.89,
    width: 36,
    height: 36,
    transform: "translate(-32.68 582.9) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP0C",
    x: 694.74,
    y: 287.44,
    width: 36,
    height: 36,
    transform: "translate(-7.22 593.44) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP2C",
    x: 796.55,
    y: 236.54,
    width: 36,
    height: 36,
    transform: "translate(58.59 650.53) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP4C",
    x: 771.1,
    y: 261.98,
    width: 36,
    height: 36,
    transform: "translate(33.14 639.98) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP4C",
    x: 745.65,
    y: 287.44,
    width: 36,
    height: 36,
    transform: "translate(7.69 629.44) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP4C",
    x: 822.01,
    y: 211.08,
    width: 36,
    height: 36,
    transform: "translate(84.05 661.07) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP4C",
    x: 847.46,
    y: 185.63,
    width: 36,
    height: 36,
    transform: "translate(109.5 671.61) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP0C",
    x: 872.91,
    y: 160.18,
    width: 36,
    height: 36,
    transform: "translate(134.95 682.16) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP5C",
    x: 898.37,
    y: 134.72,
    width: 36,
    height: 36,
    transform: "translate(160.41 692.7) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP5C",
    x: 923.82,
    y: 109.27,
    width: 36,
    height: 36,
    transform: "translate(185.86 703.24) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP5C",
    x: 949.27,
    y: 83.82,
    width: 36,
    height: 36,
    transform: "translate(211.31 713.79) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP5C",
    x: 974.73,
    y: 58.36,
    width: 36,
    height: 36,
    transform: "translate(236.77 724.33) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP0C",
    x: 1000.18,
    y: 32.91,
    width: 36,
    height: 36,
    transform: "translate(262.22 734.87) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP0C",
    x: 1025.63,
    y: 7.47,
    width: 36,
    height: 36,
    transform: "translate(287.67 745.42) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP5C",
    x: 643.83,
    y: 389.26,
    width: 36,
    height: 36,
    transform: "translate(-94.13 587.27) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP5C",
    x: 618.38,
    y: 414.71,
    width: 36,
    height: 36,
    transform: "translate(-119.58 576.73) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP0C",
    x: 592.93,
    y: 440.16,
    width: 36,
    height: 36,
    transform: "translate(-145.03 566.18) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP0C",
    x: 567.47,
    y: 465.62,
    width: 36,
    height: 36,
    transform: "translate(-170.49 555.64) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP5C",
    x: 669.29,
    y: 363.8,
    width: 36,
    height: 36,
    transform: "translate(-68.67 597.81) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP5C",
    x: 694.74,
    y: 338.34,
    width: 36,
    height: 36,
    transform: "translate(-43.22 608.35) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP0C",
    x: 720.19,
    y: 312.9,
    width: 36,
    height: 36,
    transform: "translate(-17.77 618.9) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP0C",
    x: 1076.54,
    y: 516.52,
    width: 36,
    height: 36,
    transform: "translate(-57.38 930.51) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP0C",
    x: 1051.09,
    y: 491.07,
    width: 36,
    height: 36,
    transform: "translate(-46.84 905.06) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP0C",
    x: 1025.63,
    y: 516.52,
    width: 36,
    height: 36,
    transform: "translate(-72.29 894.52) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP0C",
    x: 1076.55,
    y: 465.61,
    width: 36,
    height: 36,
    transform: "translate(-21.38 915.61) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP5C",
    x: 1025.64,
    y: 465.62,
    width: 36,
    height: 36,
    transform: "translate(-36.3 879.61) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP0C",
    x: 1000.18,
    y: 491.06,
    width: 36,
    height: 36,
    transform: "translate(-61.75 869.06) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP3C",
    x: 974.73,
    y: 516.52,
    width: 36,
    height: 36,
    transform: "translate(-87.2 858.52) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP0C",
    x: 1051.09,
    y: 440.16,
    width: 36,
    height: 36,
    transform: "translate(-10.84 890.15) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP3C",
    x: 1076.54,
    y: 414.71,
    width: 36,
    height: 36,
    transform: "translate(14.61 900.69) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP5C",
    x: 1000.18,
    y: 440.16,
    width: 36,
    height: 36,
    transform: "translate(-25.75 854.15) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP5C",
    x: 974.74,
    y: 465.61,
    width: 36,
    height: 36,
    transform: "translate(-51.2 843.62) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP0C",
    x: 949.27,
    y: 491.07,
    width: 36,
    height: 36,
    transform: "translate(-76.66 833.07) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP5C",
    x: 1025.63,
    y: 414.71,
    width: 36,
    height: 36,
    transform: "translate(-.3 864.7) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP0C",
    x: 1051.1,
    y: 389.26,
    width: 36,
    height: 36,
    transform: "translate(25.16 875.25) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP3C",
    x: 1076.54,
    y: 363.8,
    width: 36,
    height: 36,
    transform: "translate(50.61 885.78) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP3C",
    x: 923.82,
    y: 516.52,
    width: 36,
    height: 36,
    transform: "translate(-102.11 822.52) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP5C",
    x: 974.73,
    y: 414.71,
    width: 36,
    height: 36,
    transform: "translate(-15.21 828.7) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP5C",
    x: 949.27,
    y: 440.16,
    width: 36,
    height: 36,
    transform: "translate(-40.66 818.16) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP5C",
    x: 923.83,
    y: 465.61,
    width: 36,
    height: 36,
    transform: "translate(-66.11 807.62) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP5C",
    x: 1000.19,
    y: 389.25,
    width: 36,
    height: 36,
    transform: "translate(10.25 839.25) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP5C",
    x: 1025.63,
    y: 363.81,
    width: 36,
    height: 36,
    transform: "translate(35.7 849.79) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP0C",
    x: 1051.09,
    y: 338.35,
    width: 36,
    height: 36,
    transform: "translate(61.15 860.33) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP3C",
    x: 1076.55,
    y: 312.89,
    width: 36,
    height: 36,
    transform: "translate(86.61 870.88) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP3C",
    x: 872.91,
    y: 516.52,
    width: 36,
    height: 36,
    transform: "translate(-117.02 786.53) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP0C",
    x: 898.37,
    y: 491.07,
    width: 36,
    height: 36,
    transform: "translate(-91.57 797.07) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP5C",
    x: 949.28,
    y: 389.26,
    width: 36,
    height: 36,
    transform: "translate(-4.67 803.25) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP5C",
    x: 923.82,
    y: 414.7,
    width: 36,
    height: 36,
    transform: "translate(-30.12 792.7) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP1C",
    x: 898.37,
    y: 440.16,
    width: 36,
    height: 36,
    transform: "translate(-55.57 782.16) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP5C",
    x: 974.73,
    y: 363.8,
    width: 36,
    height: 36,
    transform: "translate(20.79 813.79) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP1C",
    x: 1000.18,
    y: 338.35,
    width: 36,
    height: 36,
    transform: "translate(46.24 824.33) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP5C",
    x: 1025.64,
    y: 312.9,
    width: 36,
    height: 36,
    transform: "translate(71.69 834.88) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP0C",
    x: 1051.09,
    y: 287.44,
    width: 36,
    height: 36,
    transform: "translate(97.15 845.42) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP3C",
    x: 1076.54,
    y: 261.99,
    width: 36,
    height: 36,
    transform: "translate(122.6 855.96) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP3C",
    x: 822.01,
    y: 516.52,
    width: 36,
    height: 36,
    transform: "translate(-131.93 750.53) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP0C",
    x: 847.46,
    y: 491.06,
    width: 36,
    height: 36,
    transform: "translate(-106.48 761.07) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP5C",
    x: 872.92,
    y: 465.62,
    width: 36,
    height: 36,
    transform: "translate(-81.03 771.62) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP5C",
    x: 923.82,
    y: 363.8,
    width: 36,
    height: 36,
    transform: "translate(5.88 777.79) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP5C",
    x: 898.38,
    y: 389.25,
    width: 36,
    height: 36,
    transform: "translate(-19.57 767.26) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP1C",
    x: 872.91,
    y: 414.71,
    width: 36,
    height: 36,
    transform: "translate(-45.03 756.71) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP5C",
    x: 949.27,
    y: 338.35,
    width: 36,
    height: 36,
    transform: "translate(31.33 788.34) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP1C",
    x: 974.74,
    y: 312.9,
    width: 36,
    height: 36,
    transform: "translate(56.79 798.89) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP1C",
    x: 1000.18,
    y: 287.44,
    width: 36,
    height: 36,
    transform: "translate(82.24 809.42) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP5C",
    x: 1025.63,
    y: 261.99,
    width: 36,
    height: 36,
    transform: "translate(107.69 819.97) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP0C",
    x: 1051.1,
    y: 236.54,
    width: 36,
    height: 36,
    transform: "translate(133.15 830.52) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP3C",
    x: 1076.54,
    y: 211.08,
    width: 36,
    height: 36,
    transform: "translate(158.6 841.05) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP3C",
    x: 771.1,
    y: 516.51,
    width: 36,
    height: 36,
    transform: "translate(-146.84 714.53) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP0C",
    x: 796.55,
    y: 491.07,
    width: 36,
    height: 36,
    transform: "translate(-121.39 725.08) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP5C",
    x: 822.02,
    y: 465.61,
    width: 36,
    height: 36,
    transform: "translate(-95.93 735.63) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP1C",
    x: 847.46,
    y: 440.16,
    width: 36,
    height: 36,
    transform: "translate(-70.48 746.16) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP5C",
    x: 898.37,
    y: 338.35,
    width: 36,
    height: 36,
    transform: "translate(16.42 752.34) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP0C",
    x: 872.91,
    y: 363.8,
    width: 36,
    height: 36,
    transform: "translate(-9.03 741.8) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP0C",
    x: 847.47,
    y: 389.25,
    width: 36,
    height: 36,
    transform: "translate(-34.48 731.26) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP0C",
    x: 923.83,
    y: 312.89,
    width: 36,
    height: 36,
    transform: "translate(41.88 762.89) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP0C",
    x: 949.27,
    y: 287.45,
    width: 36,
    height: 36,
    transform: "translate(67.32 773.43) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP5C",
    x: 974.73,
    y: 261.99,
    width: 36,
    height: 36,
    transform: "translate(92.78 783.97) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP1C",
    x: 1000.19,
    y: 236.54,
    width: 36,
    height: 36,
    transform: "translate(118.24 794.52) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP5C",
    x: 1025.63,
    y: 211.09,
    width: 36,
    height: 36,
    transform: "translate(143.68 805.06) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP0C",
    x: 1051.09,
    y: 185.63,
    width: 36,
    height: 36,
    transform: "translate(169.14 815.6) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP3C",
    x: 1076.55,
    y: 160.18,
    width: 36,
    height: 36,
    transform: "translate(194.6 826.15) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP0C",
    x: 745.65,
    y: 491.06,
    width: 36,
    height: 36,
    transform: "translate(-136.3 689.08) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP3C",
    x: 720.19,
    y: 516.52,
    width: 36,
    height: 36,
    transform: "translate(-161.75 678.54) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP5C",
    x: 771.11,
    y: 465.61,
    width: 36,
    height: 36,
    transform: "translate(-110.84 699.63) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP1C",
    x: 796.55,
    y: 440.16,
    width: 36,
    height: 36,
    transform: "translate(-85.39 710.17) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP5C",
    x: 822.01,
    y: 414.71,
    width: 36,
    height: 36,
    transform: "translate(-59.94 720.71) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP0C",
    x: 872.92,
    y: 312.9,
    width: 36,
    height: 36,
    transform: "translate(26.96 726.89) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP4C",
    x: 847.46,
    y: 338.34,
    width: 36,
    height: 36,
    transform: "translate(1.51 716.34) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP0C",
    x: 822.01,
    y: 363.8,
    width: 36,
    height: 36,
    transform: "translate(-23.94 705.8) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP4C",
    x: 898.37,
    y: 287.44,
    width: 36,
    height: 36,
    transform: "translate(52.42 737.43) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP0C",
    x: 923.82,
    y: 261.99,
    width: 36,
    height: 36,
    transform: "translate(77.87 747.97) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP0C",
    x: 949.28,
    y: 236.54,
    width: 36,
    height: 36,
    transform: "translate(103.32 758.52) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP1C",
    x: 974.73,
    y: 211.08,
    width: 36,
    height: 36,
    transform: "translate(128.78 769.06) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP1C",
    x: 1000.18,
    y: 185.63,
    width: 36,
    height: 36,
    transform: "translate(154.23 779.6) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP5C",
    x: 1025.64,
    y: 160.18,
    width: 36,
    height: 36,
    transform: "translate(179.68 790.15) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP0C",
    x: 1051.09,
    y: 134.72,
    width: 36,
    height: 36,
    transform: "translate(205.14 800.69) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP3C",
    x: 1076.54,
    y: 109.27,
    width: 36,
    height: 36,
    transform: "translate(230.59 811.23) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP5C",
    x: 720.2,
    y: 465.62,
    width: 36,
    height: 36,
    transform: "translate(-125.76 663.64) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP0C",
    x: 694.74,
    y: 491.07,
    width: 36,
    height: 36,
    transform: "translate(-151.21 653.09) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP3C",
    x: 669.29,
    y: 516.52,
    width: 36,
    height: 36,
    transform: "translate(-176.66 642.54) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP1C",
    x: 745.65,
    y: 440.16,
    width: 36,
    height: 36,
    transform: "translate(-100.3 674.17) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP1C",
    x: 771.1,
    y: 414.7,
    width: 36,
    height: 36,
    transform: "translate(-74.85 684.71) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP0C",
    x: 796.56,
    y: 389.26,
    width: 36,
    height: 36,
    transform: "translate(-49.4 695.27) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP2C",
    x: 847.46,
    y: 287.44,
    width: 36,
    height: 36,
    transform: "translate(37.51 701.43) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP4C",
    x: 822.02,
    y: 312.89,
    width: 36,
    height: 36,
    transform: "translate(12.06 690.9) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP4C",
    x: 796.55,
    y: 338.35,
    width: 36,
    height: 36,
    transform: "translate(-13.4 680.35) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP4C",
    x: 872.91,
    y: 261.99,
    width: 36,
    height: 36,
    transform: "translate(62.96 711.98) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP4C",
    x: 898.38,
    y: 236.54,
    width: 36,
    height: 36,
    transform: "translate(88.42 722.53) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP0C",
    x: 923.82,
    y: 211.08,
    width: 36,
    height: 36,
    transform: "translate(113.87 733.06) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP5C",
    x: 949.27,
    y: 185.63,
    width: 36,
    height: 36,
    transform: "translate(139.32 743.61) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP5C",
    x: 974.74,
    y: 160.18,
    width: 36,
    height: 36,
    transform: "translate(164.78 754.16) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP5C",
    x: 1000.18,
    y: 134.72,
    width: 36,
    height: 36,
    transform: "translate(190.23 764.69) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP5C",
    x: 1025.63,
    y: 109.28,
    width: 36,
    height: 36,
    transform: "translate(215.68 775.24) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP0C",
    x: 1051.1,
    y: 83.82,
    width: 36,
    height: 36,
    transform: "translate(241.14 785.79) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP0C",
    x: 1076.54,
    y: 58.36,
    width: 36,
    height: 36,
    transform: "translate(266.59 796.32) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP5C",
    x: 694.74,
    y: 440.15,
    width: 36,
    height: 36,
    transform: "translate(-115.21 638.17) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP5C",
    x: 669.3,
    y: 465.61,
    width: 36,
    height: 36,
    transform: "translate(-140.66 627.64) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP0C",
    x: 643.83,
    y: 491.07,
    width: 36,
    height: 36,
    transform: "translate(-166.12 617.09) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP0C",
    x: 618.38,
    y: 516.52,
    width: 36,
    height: 36,
    transform: "translate(-191.57 606.55) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP5C",
    x: 720.19,
    y: 414.71,
    width: 36,
    height: 36,
    transform: "translate(-89.76 648.72) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP5C",
    x: 745.66,
    y: 389.25,
    width: 36,
    height: 36,
    transform: "translate(-64.3 659.27) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP0C",
    x: 771.1,
    y: 363.8,
    width: 36,
    height: 36,
    transform: "translate(-38.85 669.8) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP0C",
    x: 822.01,
    y: 261.99,
    width: 36,
    height: 36,
    transform: "translate(48.05 675.98) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP2C",
    x: 796.55,
    y: 287.44,
    width: 36,
    height: 36,
    transform: "translate(22.59 665.44) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP0C",
    x: 771.11,
    y: 312.89,
    width: 36,
    height: 36,
    transform: "translate(-2.85 654.9) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP2C",
    x: 847.47,
    y: 236.53,
    width: 36,
    height: 36,
    transform: "translate(73.51 686.53) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP0C",
    x: 872.91,
    y: 211.09,
    width: 36,
    height: 36,
    transform: "translate(98.95 697.07) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP5C",
    x: 898.37,
    y: 185.63,
    width: 36,
    height: 36,
    transform: "translate(124.41 707.61) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP5C",
    x: 923.83,
    y: 160.18,
    width: 36,
    height: 36,
    transform: "translate(149.87 718.16) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP5C",
    x: 949.27,
    y: 134.73,
    width: 36,
    height: 36,
    transform: "translate(175.31 728.7) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP5C",
    x: 974.73,
    y: 109.27,
    width: 36,
    height: 36,
    transform: "translate(200.77 739.24) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP5C",
    x: 1000.19,
    y: 83.82,
    width: 36,
    height: 36,
    transform: "translate(226.23 749.79) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP5C",
    x: 1025.63,
    y: 58.37,
    width: 36,
    height: 36,
    transform: "translate(251.67 760.33) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP0C",
    x: 1051.09,
    y: 32.91,
    width: 36,
    height: 36,
    transform: "translate(277.13 770.87) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP0C",
    x: 1076.55,
    y: 7.46,
    width: 36,
    height: 36,
    transform: "translate(302.59 781.42) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP5C",
    x: 669.29,
    y: 414.7,
    width: 36,
    height: 36,
    transform: "translate(-104.67 612.72) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP5C",
    x: 643.83,
    y: 440.16,
    width: 36,
    height: 36,
    transform: "translate(-130.12 602.18) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP5C",
    x: 618.39,
    y: 465.62,
    width: 36,
    height: 36,
    transform: "translate(-155.58 591.65) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP0C",
    x: 592.93,
    y: 491.06,
    width: 36,
    height: 36,
    transform: "translate(-181.03 581.09) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP0C",
    x: 567.47,
    y: 516.52,
    width: 36,
    height: 36,
    transform: "translate(-206.48 570.55) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP5C",
    x: 694.75,
    y: 389.25,
    width: 36,
    height: 36,
    transform: "translate(-79.21 623.27) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP5C",
    x: 720.19,
    y: 363.8,
    width: 36,
    height: 36,
    transform: "translate(-53.76 633.81) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP5C",
    x: 745.65,
    y: 338.35,
    width: 36,
    height: 36,
    transform: "translate(-28.31 644.35) rotate(-45)"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP0C",
    x: 7.46,
    y: 567.47,
    width: 36,
    height: 36,
    transform: "translate(-406.54 189.48) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP0C",
    x: 32.91,
    y: 592.92,
    width: 36,
    height: 36,
    transform: "translate(-417.08 214.94) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP0C",
    x: 7.46,
    y: 618.38,
    width: 36,
    height: 36,
    transform: "translate(-442.53 204.39) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP0C",
    x: 58.36,
    y: 567.48,
    width: 36,
    height: 36,
    transform: "translate(-391.63 225.48) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP5C",
    x: 58.36,
    y: 618.39,
    width: 36,
    height: 36,
    transform: "translate(-427.63 240.39) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP0C",
    x: 32.91,
    y: 643.83,
    width: 36,
    height: 36,
    transform: "translate(-453.08 229.85) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP3C",
    x: 7.46,
    y: 669.28,
    width: 36,
    height: 36,
    transform: "translate(-478.53 219.3) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP0C",
    x: 83.82,
    y: 592.93,
    width: 36,
    height: 36,
    transform: "translate(-402.17 250.93) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP3C",
    x: 109.27,
    y: 567.47,
    width: 36,
    height: 36,
    transform: "translate(-376.72 261.47) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP5C",
    x: 83.82,
    y: 643.83,
    width: 36,
    height: 36,
    transform: "translate(-438.17 265.84) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP5C",
    x: 58.36,
    y: 669.29,
    width: 36,
    height: 36,
    transform: "translate(-463.62 255.3) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP5C",
    x: 58.36,
    y: 720.41,
    width: 36,
    height: 36,
    transform: "translate(-499.77 270.27) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP0C",
    x: 32.91,
    y: 694.75,
    width: 36,
    height: 36,
    transform: "translate(-489.08 244.76) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP5C",
    x: 109.27,
    y: 618.38,
    width: 36,
    height: 36,
    transform: "translate(-412.71 276.38) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP0C",
    x: 134.72,
    y: 592.93,
    width: 36,
    height: 36,
    transform: "translate(-387.26 286.93) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP3C",
    x: 160.18,
    y: 567.47,
    width: 36,
    height: 36,
    transform: "translate(-361.81 297.47) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP3C",
    x: 7.46,
    y: 720.19,
    width: 36,
    height: 36,
    transform: "translate(-514.52 234.21) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP5C",
    x: 109.27,
    y: 669.28,
    width: 36,
    height: 36,
    transform: "translate(-448.71 291.29) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP5C",
    x: 83.82,
    y: 694.74,
    width: 36,
    height: 36,
    transform: "translate(-474.16 280.75) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP5C",
    x: 134.72,
    y: 643.84,
    width: 36,
    height: 36,
    transform: "translate(-423.26 301.84) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP5C",
    x: 160.18,
    y: 618.38,
    width: 36,
    height: 36,
    transform: "translate(-397.8 312.38) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP0C",
    x: 185.63,
    y: 592.92,
    width: 36,
    height: 36,
    transform: "translate(-372.35 322.92) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP3C",
    x: 211.08,
    y: 567.48,
    width: 36,
    height: 36,
    transform: "translate(-346.9 333.47) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP3C",
    x: 7.46,
    y: 771.1,
    width: 36,
    height: 36,
    transform: "translate(-550.52 249.12) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP0C",
    x: 32.91,
    y: 745.65,
    width: 36,
    height: 36,
    transform: "translate(-525.07 259.67) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP5C",
    x: 134.72,
    y: 694.75,
    width: 36,
    height: 36,
    transform: "translate(-459.26 316.75) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP5C",
    x: 109.27,
    y: 720.19,
    width: 36,
    height: 36,
    transform: "translate(-484.7 306.2) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP1C",
    x: 83.82,
    y: 745.64,
    width: 36,
    height: 36,
    transform: "translate(-510.16 295.66) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP5C",
    x: 160.18,
    y: 669.29,
    width: 36,
    height: 36,
    transform: "translate(-433.8 327.29) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP1C",
    x: 185.63,
    y: 643.83,
    width: 36,
    height: 36,
    transform: "translate(-408.35 337.83) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP5C",
    x: 211.08,
    y: 618.39,
    width: 36,
    height: 36,
    transform: "translate(-382.9 348.38) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP0C",
    x: 236.54,
    y: 592.93,
    width: 36,
    height: 36,
    transform: "translate(-357.44 358.92) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP3C",
    x: 261.99,
    y: 567.47,
    width: 36,
    height: 36,
    transform: "translate(-331.99 369.46) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP3C",
    x: 7.46,
    y: 822,
    width: 36,
    height: 36,
    transform: "translate(-586.52 264.03) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP0C",
    x: 32.91,
    y: 796.56,
    width: 36,
    height: 36,
    transform: "translate(-561.07 274.58) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP5C",
    x: 58.36,
    y: 771.11,
    width: 36,
    height: 36,
    transform: "translate(-535.62 285.12) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP5C",
    x: 160.18,
    y: 720.19,
    width: 36,
    height: 36,
    transform: "translate(-469.79 342.2) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP5C",
    x: 134.72,
    y: 745.65,
    width: 36,
    height: 36,
    transform: "translate(-495.25 331.66) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP1C",
    x: 109.27,
    y: 771.11,
    width: 36,
    height: 36,
    transform: "translate(-520.71 321.12) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP5C",
    x: 185.63,
    y: 694.74,
    width: 36,
    height: 36,
    transform: "translate(-444.34 352.74) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP1C",
    x: 211.08,
    y: 669.29,
    width: 36,
    height: 36,
    transform: "translate(-418.89 363.29) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP1C",
    x: 236.54,
    y: 643.83,
    width: 36,
    height: 36,
    transform: "translate(-393.44 373.83) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP5C",
    x: 261.99,
    y: 618.38,
    width: 36,
    height: 36,
    transform: "translate(-367.98 384.37) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP0C",
    x: 287.44,
    y: 592.93,
    width: 36,
    height: 36,
    transform: "translate(-342.53 394.92) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP3C",
    x: 312.9,
    y: 567.48,
    width: 36,
    height: 36,
    transform: "translate(-317.08 405.46) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP3C",
    x: 7.46,
    y: 872.91,
    width: 36,
    height: 36,
    transform: "translate(-622.51 278.94) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP0C",
    x: 32.91,
    y: 847.47,
    width: 36,
    height: 36,
    transform: "translate(-597.07 289.49) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP5C",
    x: 58.36,
    y: 822.01,
    width: 36,
    height: 36,
    transform: "translate(-571.61 300.03) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP1C",
    x: 83.82,
    y: 796.55,
    width: 36,
    height: 36,
    transform: "translate(-546.15 310.57) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP5C",
    x: 185.63,
    y: 745.64,
    width: 36,
    height: 36,
    transform: "translate(-480.34 367.65) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP0C",
    x: 160.18,
    y: 771.1,
    width: 36,
    height: 36,
    transform: "translate(-505.79 357.11) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP0C",
    x: 134.72,
    y: 796.56,
    width: 36,
    height: 36,
    transform: "translate(-531.25 346.57) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP0C",
    x: 211.08,
    y: 720.2,
    width: 36,
    height: 36,
    transform: "translate(-454.89 378.2) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP0C",
    x: 236.54,
    y: 694.74,
    width: 36,
    height: 36,
    transform: "translate(-429.43 388.74) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP5C",
    x: 261.99,
    y: 669.28,
    width: 36,
    height: 36,
    transform: "translate(-403.98 399.28) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP1C",
    x: 287.44,
    y: 643.84,
    width: 36,
    height: 36,
    transform: "translate(-378.53 409.83) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP5C",
    x: 312.9,
    y: 618.38,
    width: 36,
    height: 36,
    transform: "translate(-353.07 420.37) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP0C",
    x: 338.35,
    y: 592.93,
    width: 36,
    height: 36,
    transform: "translate(-327.62 430.91) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP3C",
    x: 363.8,
    y: 567.48,
    width: 36,
    height: 36,
    transform: "translate(-302.17 441.46) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP0C",
    x: 32.91,
    y: 898.37,
    width: 36,
    height: 36,
    transform: "translate(-633.06 304.4) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP3C",
    x: 7.46,
    y: 923.82,
    width: 36,
    height: 36,
    transform: "translate(-658.51 293.85) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP5C",
    x: 58.36,
    y: 872.92,
    width: 36,
    height: 36,
    transform: "translate(-607.61 314.94) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP1C",
    x: 83.82,
    y: 847.46,
    width: 36,
    height: 36,
    transform: "translate(-582.15 325.48) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP5C",
    x: 109.27,
    y: 822.01,
    width: 36,
    height: 36,
    transform: "translate(-556.7 336.03) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP0C",
    x: 211.08,
    y: 771.11,
    width: 36,
    height: 36,
    transform: "translate(-490.89 393.11) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP4C",
    x: 185.63,
    y: 796.56,
    width: 36,
    height: 36,
    transform: "translate(-516.34 382.57) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP0C",
    x: 160.18,
    y: 822,
    width: 36,
    height: 36,
    transform: "translate(-541.79 372.02) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP4C",
    x: 236.54,
    y: 745.65,
    width: 36,
    height: 36,
    transform: "translate(-465.43 403.65) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP0C",
    x: 261.99,
    y: 720.19,
    width: 36,
    height: 36,
    transform: "translate(-439.97 414.19) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP0C",
    x: 287.44,
    y: 694.75,
    width: 36,
    height: 36,
    transform: "translate(-414.53 424.74) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP1C",
    x: 312.9,
    y: 669.29,
    width: 36,
    height: 36,
    transform: "translate(-389.07 435.28) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP1C",
    x: 338.35,
    y: 643.83,
    width: 36,
    height: 36,
    transform: "translate(-363.62 445.82) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP5C",
    x: 363.8,
    y: 618.39,
    width: 36,
    height: 36,
    transform: "translate(-338.17 456.37) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP0C",
    x: 389.26,
    y: 592.93,
    width: 36,
    height: 36,
    transform: "translate(-312.71 466.91) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP3C",
    x: 414.71,
    y: 567.47,
    width: 36,
    height: 36,
    transform: "translate(-287.26 477.45) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP5C",
    x: 58.36,
    y: 923.83,
    width: 36,
    height: 36,
    transform: "translate(-643.61 329.85) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP0C",
    x: 32.91,
    y: 949.28,
    width: 36,
    height: 36,
    transform: "translate(-669.06 319.31) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP3C",
    x: 7.46,
    y: 974.72,
    width: 36,
    height: 36,
    transform: "translate(-694.5 308.76) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP1C",
    x: 83.82,
    y: 898.36,
    width: 36,
    height: 36,
    transform: "translate(-618.14 340.39) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP1C",
    x: 109.27,
    y: 872.92,
    width: 36,
    height: 36,
    transform: "translate(-592.7 350.94) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP0C",
    x: 134.72,
    y: 847.47,
    width: 36,
    height: 36,
    transform: "translate(-567.25 361.48) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP2C",
    x: 236.54,
    y: 796.55,
    width: 36,
    height: 36,
    transform: "translate(-501.42 418.56) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP4C",
    x: 211.09,
    y: 822.02,
    width: 36,
    height: 36,
    transform: "translate(-526.89 408.03) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP4C",
    x: 185.63,
    y: 847.47,
    width: 36,
    height: 36,
    transform: "translate(-552.34 397.48) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP4C",
    x: 261.99,
    y: 771.1,
    width: 36,
    height: 36,
    transform: "translate(-475.97 429.1) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP4C",
    x: 287.44,
    y: 745.65,
    width: 36,
    height: 36,
    transform: "translate(-450.52 439.65) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP0C",
    x: 312.9,
    y: 720.19,
    width: 36,
    height: 36,
    transform: "translate(-425.06 450.19) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP5C",
    x: 338.35,
    y: 694.74,
    width: 36,
    height: 36,
    transform: "translate(-399.61 460.73) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP5C",
    x: 363.8,
    y: 669.29,
    width: 36,
    height: 36,
    transform: "translate(-374.16 471.28) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP5C",
    x: 389.26,
    y: 643.84,
    width: 36,
    height: 36,
    transform: "translate(-348.71 481.82) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP5C",
    x: 414.71,
    y: 618.38,
    width: 36,
    height: 36,
    transform: "translate(-323.25 492.36) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP0C",
    x: 440.16,
    y: 592.93,
    width: 36,
    height: 36,
    transform: "translate(-297.8 502.91) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP0C",
    x: 465.62,
    y: 567.48,
    width: 36,
    height: 36,
    transform: "translate(-272.35 513.45) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP5C",
    x: 83.82,
    y: 949.27,
    width: 36,
    height: 36,
    transform: "translate(-654.14 355.3) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP5C",
    x: 58.36,
    y: 974.73,
    width: 36,
    height: 36,
    transform: "translate(-679.6 344.76) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP0C",
    x: 32.91,
    y: 1000.19,
    width: 36,
    height: 36,
    transform: "translate(-705.06 334.22) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP0C",
    x: 7.46,
    y: 1025.63,
    width: 36,
    height: 36,
    transform: "translate(-730.5 323.67) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP5C",
    x: 109.27,
    y: 923.83,
    width: 36,
    height: 36,
    transform: "translate(-628.7 365.85) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP5C",
    x: 134.72,
    y: 898.37,
    width: 36,
    height: 36,
    transform: "translate(-603.24 376.39) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP0C",
    x: 160.18,
    y: 872.91,
    width: 36,
    height: 36,
    transform: "translate(-577.78 386.93) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP0C",
    x: 516.53,
    y: 1076.55,
    width: 36,
    height: 36,
    transform: "translate(-617.41 698.55) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP0C",
    x: 491.07,
    y: 1051.09,
    width: 36,
    height: 36,
    transform: "translate(-606.86 673.1) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP0C",
    x: 465.62,
    y: 1076.54,
    width: 36,
    height: 36,
    transform: "translate(-632.31 662.56) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP0C",
    x: 516.52,
    y: 1025.64,
    width: 36,
    height: 36,
    transform: "translate(-581.41 683.64) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP5C",
    x: 465.62,
    y: 1025.63,
    width: 36,
    height: 36,
    transform: "translate(-596.31 647.64) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP0C",
    x: 440.17,
    y: 1051.1,
    width: 36,
    height: 36,
    transform: "translate(-621.77 637.1) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP3C",
    x: 414.72,
    y: 1076.55,
    width: 36,
    height: 36,
    transform: "translate(-647.23 626.56) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP0C",
    x: 491.08,
    y: 1000.18,
    width: 36,
    height: 36,
    transform: "translate(-570.86 658.19) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP3C",
    x: 516.53,
    y: 974.74,
    width: 36,
    height: 36,
    transform: "translate(-545.41 668.73) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP5C",
    x: 440.17,
    y: 1000.19,
    width: 36,
    height: 36,
    transform: "translate(-585.78 622.19) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP5C",
    x: 414.71,
    y: 1025.63,
    width: 36,
    height: 36,
    transform: "translate(-611.22 611.64) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP0C",
    x: 389.26,
    y: 1051.09,
    width: 36,
    height: 36,
    transform: "translate(-636.68 601.11) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP5C",
    x: 465.62,
    y: 974.73,
    width: 36,
    height: 36,
    transform: "translate(-560.32 632.74) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP0C",
    x: 491.07,
    y: 949.27,
    width: 36,
    height: 36,
    transform: "translate(-534.86 643.27) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP3C",
    x: 516.53,
    y: 923.83,
    width: 36,
    height: 36,
    transform: "translate(-509.42 653.82) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP3C",
    x: 363.81,
    y: 1076.55,
    width: 36,
    height: 36,
    transform: "translate(-662.14 590.56) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP5C",
    x: 414.72,
    y: 974.73,
    width: 36,
    height: 36,
    transform: "translate(-575.23 596.74) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP5C",
    x: 389.27,
    y: 1000.18,
    width: 36,
    height: 36,
    transform: "translate(-600.68 586.2) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP5C",
    x: 363.8,
    y: 1025.64,
    width: 36,
    height: 36,
    transform: "translate(-626.14 575.65) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP5C",
    x: 440.16,
    y: 949.28,
    width: 36,
    height: 36,
    transform: "translate(-549.78 607.28) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP5C",
    x: 465.63,
    y: 923.82,
    width: 36,
    height: 36,
    transform: "translate(-524.32 617.83) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP0C",
    x: 491.08,
    y: 898.37,
    width: 36,
    height: 36,
    transform: "translate(-498.87 628.37) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP3C",
    x: 516.52,
    y: 872.92,
    width: 36,
    height: 36,
    transform: "translate(-473.42 638.91) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP3C",
    x: 312.91,
    y: 1076.54,
    width: 36,
    height: 36,
    transform: "translate(-677.04 554.57) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP0C",
    x: 338.36,
    y: 1051.1,
    width: 36,
    height: 36,
    transform: "translate(-651.59 565.11) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP5C",
    x: 389.26,
    y: 949.27,
    width: 36,
    height: 36,
    transform: "translate(-564.68 571.28) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP5C",
    x: 363.81,
    y: 974.74,
    width: 36,
    height: 36,
    transform: "translate(-590.14 560.74) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP1C",
    x: 338.35,
    y: 1000.19,
    width: 36,
    height: 36,
    transform: "translate(-615.6 550.2) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP5C",
    x: 414.71,
    y: 923.82,
    width: 36,
    height: 36,
    transform: "translate(-539.23 581.82) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP1C",
    x: 440.17,
    y: 898.38,
    width: 36,
    height: 36,
    transform: "translate(-513.78 592.37) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP5C",
    x: 465.62,
    y: 872.91,
    width: 36,
    height: 36,
    transform: "translate(-488.32 602.91) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP0C",
    x: 491.07,
    y: 847.46,
    width: 36,
    height: 36,
    transform: "translate(-462.87 613.45) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP3C",
    x: 516.53,
    y: 822.02,
    width: 36,
    height: 36,
    transform: "translate(-437.43 624) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP3C",
    x: 262,
    y: 1076.55,
    width: 36,
    height: 36,
    transform: "translate(-691.96 518.57) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP0C",
    x: 287.45,
    y: 1051.1,
    width: 36,
    height: 36,
    transform: "translate(-666.5 529.12) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP5C",
    x: 312.9,
    y: 1025.63,
    width: 36,
    height: 36,
    transform: "translate(-641.04 539.65) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP5C",
    x: 363.8,
    y: 923.83,
    width: 36,
    height: 36,
    transform: "translate(-554.15 545.83) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP5C",
    x: 338.35,
    y: 949.27,
    width: 36,
    height: 36,
    transform: "translate(-579.59 535.28) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP1C",
    x: 312.9,
    y: 974.73,
    width: 36,
    height: 36,
    transform: "translate(-605.05 524.75) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP5C",
    x: 389.26,
    y: 898.37,
    width: 36,
    height: 36,
    transform: "translate(-528.69 556.38) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP1C",
    x: 414.71,
    y: 872.91,
    width: 36,
    height: 36,
    transform: "translate(-503.23 566.91) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP1C",
    x: 440.16,
    y: 847.47,
    width: 36,
    height: 36,
    transform: "translate(-477.79 577.46) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP5C",
    x: 465.62,
    y: 822.01,
    width: 36,
    height: 36,
    transform: "translate(-452.33 588.01) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP0C",
    x: 491.07,
    y: 796.55,
    width: 36,
    height: 36,
    transform: "translate(-426.87 598.54) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP3C",
    x: 516.52,
    y: 771.11,
    width: 36,
    height: 36,
    transform: "translate(-401.43 609.09) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP3C",
    x: 211.08,
    y: 1076.55,
    width: 36,
    height: 36,
    transform: "translate(-706.87 482.57) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP0C",
    x: 236.54,
    y: 1051.09,
    width: 36,
    height: 36,
    transform: "translate(-681.41 493.12) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP5C",
    x: 261.99,
    y: 1025.64,
    width: 36,
    height: 36,
    transform: "translate(-655.96 503.66) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP1C",
    x: 287.44,
    y: 1000.19,
    width: 36,
    height: 36,
    transform: "translate(-630.51 514.2) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP5C",
    x: 338.36,
    y: 898.37,
    width: 36,
    height: 36,
    transform: "translate(-543.6 520.38) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP0C",
    x: 312.9,
    y: 923.82,
    width: 36,
    height: 36,
    transform: "translate(-569.05 509.83) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP0C",
    x: 287.44,
    y: 949.28,
    width: 36,
    height: 36,
    transform: "translate(-594.51 499.29) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP0C",
    x: 363.8,
    y: 872.92,
    width: 36,
    height: 36,
    transform: "translate(-518.15 530.92) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP0C",
    x: 389.26,
    y: 847.46,
    width: 36,
    height: 36,
    transform: "translate(-492.69 541.46) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP5C",
    x: 414.72,
    y: 822.01,
    width: 36,
    height: 36,
    transform: "translate(-467.24 552.01) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP1C",
    x: 440.16,
    y: 796.56,
    width: 36,
    height: 36,
    transform: "translate(-441.79 562.55) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP5C",
    x: 465.62,
    y: 771.1,
    width: 36,
    height: 36,
    transform: "translate(-416.33 573.09) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP0C",
    x: 491.08,
    y: 745.65,
    width: 36,
    height: 36,
    transform: "translate(-390.88 583.64) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP3C",
    x: 516.52,
    y: 720.2,
    width: 36,
    height: 36,
    transform: "translate(-365.43 594.18) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP0C",
    x: 185.64,
    y: 1051.1,
    width: 36,
    height: 36,
    transform: "translate(-696.32 457.12) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP3C",
    x: 160.18,
    y: 1076.54,
    width: 36,
    height: 36,
    transform: "translate(-721.77 446.57) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP5C",
    x: 211.08,
    y: 1025.64,
    width: 36,
    height: 36,
    transform: "translate(-670.87 467.66) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP1C",
    x: 236.54,
    y: 1000.18,
    width: 36,
    height: 36,
    transform: "translate(-645.41 478.2) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP5C",
    x: 262,
    y: 974.74,
    width: 36,
    height: 36,
    transform: "translate(-619.96 488.75) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP0C",
    x: 312.9,
    y: 872.91,
    width: 36,
    height: 36,
    transform: "translate(-533.05 494.92) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP4C",
    x: 287.45,
    y: 898.38,
    width: 36,
    height: 36,
    transform: "translate(-558.51 484.39) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP0C",
    x: 261.99,
    y: 923.83,
    width: 36,
    height: 36,
    transform: "translate(-583.97 473.84) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP4C",
    x: 338.35,
    y: 847.46,
    width: 36,
    height: 36,
    transform: "translate(-507.6 505.46) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP0C",
    x: 363.81,
    y: 822.02,
    width: 36,
    height: 36,
    transform: "translate(-482.16 516.01) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP0C",
    x: 389.26,
    y: 796.55,
    width: 36,
    height: 36,
    transform: "translate(-456.69 526.55) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP1C",
    x: 414.71,
    y: 771.1,
    width: 36,
    height: 36,
    transform: "translate(-431.24 537.09) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP1C",
    x: 440.17,
    y: 745.66,
    width: 36,
    height: 36,
    transform: "translate(-405.8 547.64) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP5C",
    x: 465.62,
    y: 720.2,
    width: 36,
    height: 36,
    transform: "translate(-380.33 558.18) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP0C",
    x: 491.07,
    y: 694.74,
    width: 36,
    height: 36,
    transform: "translate(-354.88 568.72) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP3C",
    x: 516.53,
    y: 669.3,
    width: 36,
    height: 36,
    transform: "translate(-329.44 579.27) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP5C",
    x: 160.18,
    y: 1025.63,
    width: 36,
    height: 36,
    transform: "translate(-685.77 431.66) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP0C",
    x: 134.72,
    y: 1051.09,
    width: 36,
    height: 36,
    transform: "translate(-711.23 421.12) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP3C",
    x: 109.27,
    y: 1076.55,
    width: 36,
    height: 36,
    transform: "translate(-736.69 410.58) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP1C",
    x: 185.63,
    y: 1000.19,
    width: 36,
    height: 36,
    transform: "translate(-660.33 442.21) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP1C",
    x: 211.09,
    y: 974.74,
    width: 36,
    height: 36,
    transform: "translate(-634.87 452.76) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP0C",
    x: 236.54,
    y: 949.27,
    width: 36,
    height: 36,
    transform: "translate(-609.41 463.29) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP2C",
    x: 287.44,
    y: 847.47,
    width: 36,
    height: 36,
    transform: "translate(-522.52 469.47) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP4C",
    x: 261.99,
    y: 872.91,
    width: 36,
    height: 36,
    transform: "translate(-547.96 458.92) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP4C",
    x: 236.55,
    y: 898.37,
    width: 36,
    height: 36,
    transform: "translate(-573.42 448.39) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP4C",
    x: 312.91,
    y: 822.01,
    width: 36,
    height: 36,
    transform: "translate(-497.06 480.02) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP4C",
    x: 338.35,
    y: 796.55,
    width: 36,
    height: 36,
    transform: "translate(-471.6 490.55) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP0C",
    x: 363.8,
    y: 771.11,
    width: 36,
    height: 36,
    transform: "translate(-446.16 501.1) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP5C",
    x: 389.27,
    y: 745.65,
    width: 36,
    height: 36,
    transform: "translate(-420.7 511.65) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP5C",
    x: 414.71,
    y: 720.19,
    width: 36,
    height: 36,
    transform: "translate(-395.24 522.18) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP5C",
    x: 440.16,
    y: 694.75,
    width: 36,
    height: 36,
    transform: "translate(-369.8 532.73) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP5C",
    x: 465.63,
    y: 669.29,
    width: 36,
    height: 36,
    transform: "translate(-344.34 543.28) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP0C",
    x: 491.07,
    y: 643.83,
    width: 36,
    height: 36,
    transform: "translate(-318.89 553.81) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP0C",
    x: 516.52,
    y: 618.39,
    width: 36,
    height: 36,
    transform: "translate(-293.44 564.36) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP5C",
    x: 134.72,
    y: 1000.19,
    width: 36,
    height: 36,
    transform: "translate(-675.24 406.21) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP5C",
    x: 109.27,
    y: 1025.64,
    width: 36,
    height: 36,
    transform: "translate(-700.69 395.67) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP0C",
    x: 83.82,
    y: 1051.08,
    width: 36,
    height: 36,
    transform: "translate(-726.13 385.12) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP0C",
    x: 58.36,
    y: 1076.55,
    width: 36,
    height: 36,
    transform: "translate(-751.6 374.58) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP5C",
    x: 160.19,
    y: 974.73,
    width: 36,
    height: 36,
    transform: "translate(-649.78 416.76) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP5C",
    x: 185.63,
    y: 949.28,
    width: 36,
    height: 36,
    transform: "translate(-624.33 427.3) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP0C",
    x: 211.08,
    y: 923.83,
    width: 36,
    height: 36,
    transform: "translate(-598.88 437.84) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP0C",
    x: 262,
    y: 822.01,
    width: 36,
    height: 36,
    transform: "translate(-511.97 444.02) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP2C",
    x: 236.54,
    y: 847.46,
    width: 36,
    height: 36,
    transform: "translate(-537.42 433.47) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP0C",
    x: 211.08,
    y: 872.92,
    width: 36,
    height: 36,
    transform: "translate(-562.88 422.93) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP2C",
    x: 287.44,
    y: 796.56,
    width: 36,
    height: 36,
    transform: "translate(-486.52 454.56) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP0C",
    x: 312.9,
    y: 771.1,
    width: 36,
    height: 36,
    transform: "translate(-461.06 465.1) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP5C",
    x: 338.36,
    y: 745.65,
    width: 36,
    height: 36,
    transform: "translate(-435.61 475.65) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP5C",
    x: 363.8,
    y: 720.2,
    width: 36,
    height: 36,
    transform: "translate(-410.16 486.19) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP5C",
    x: 389.26,
    y: 694.74,
    width: 36,
    height: 36,
    transform: "translate(-384.7 496.73) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP5C",
    x: 414.72,
    y: 669.29,
    width: 36,
    height: 36,
    transform: "translate(-359.25 507.28) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP5C",
    x: 440.16,
    y: 643.84,
    width: 36,
    height: 36,
    transform: "translate(-333.8 517.82) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP5C",
    x: 465.62,
    y: 618.38,
    width: 36,
    height: 36,
    transform: "translate(-308.34 528.36) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP0C",
    x: 491.07,
    y: 592.93,
    width: 36,
    height: 36,
    transform: "translate(-282.89 538.9) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP0C",
    x: 516.52,
    y: 567.48,
    width: 36,
    height: 36,
    transform: "translate(-257.44 549.45) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP5C",
    x: 109.27,
    y: 974.73,
    width: 36,
    height: 36,
    transform: "translate(-664.69 380.76) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP5C",
    x: 83.82,
    y: 1000.18,
    width: 36,
    height: 36,
    transform: "translate(-690.14 370.21) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP5C",
    x: 58.36,
    y: 1025.64,
    width: 36,
    height: 36,
    transform: "translate(-715.6 359.67) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP0C",
    x: 32.91,
    y: 1051.09,
    width: 36,
    height: 36,
    transform: "translate(-741.05 349.13) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP0C",
    x: 7.46,
    y: 1076.54,
    width: 36,
    height: 36,
    transform: "translate(-766.5 338.58) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP5C",
    x: 134.72,
    y: 949.28,
    width: 36,
    height: 36,
    transform: "translate(-639.24 391.3) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP5C",
    x: 160.18,
    y: 923.82,
    width: 36,
    height: 36,
    transform: "translate(-613.78 401.84) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "sixthP5C",
    x: 185.64,
    y: 898.38,
    width: 36,
    height: 36,
    transform: "translate(-588.33 412.39) rotate(-45)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSixthPClear);
export default __webpack_public_path__ + "static/media/SixthP_Clear.17070f4a1a903f8304e518b260236b06.svg";
export { ForwardRef as ReactComponent };